document.addEventListener('DOMContentLoaded',()=>{

  let ef_transaction_id_get = '';
  const storedTxId = sessionStorage.getItem('ef_transaction_id');
  if (storedTxId) {
    ef_transaction_id_get = storedTxId;
  }

if (document.cookie.includes('hc-has-account=1')) {

        window.location.href = 'app.humecare.com/get-started'
        
    }else{      
      
        function getPatientDataOnLoad() {
            return JSON.parse(localStorage.getItem('patient_starter') || '{}');
        }      

        function initPatientSubmit() {
            const submitted = sessionStorage.getItem('patient_api_submitted');
            if (!submitted) {
                submitPatientDataOnLoad();
            }
        }

        async function submitPatientDataOnLoad() {
            sessionStorage.setItem('patient_api_submitted', 'true');
            const data = getPatientDataOnLoad();
          if (data.first_name && data.first_name.trim() !== '') {
            const payloadOnLoad = {
                programCode   : 'glp1',
                offer         : 2,
                patientStarter: {
                    firstName      : data.first_name    || '',
                    lastName       : data.last_name     || '',
                    email          : data.email         || '',
                    dateOfBirth    : formatDate(data.date_of_birth),
                    gender         : data.gender        ?? null,
                    weight         : data.weight        ?? null,
                    height         : data.height        ?? null,
                    address: {
                        address    : data.address?.address    || '',
                        address2   : data.address?.address2   || '',
                        zipCode    : data.address?.zip_code   || '',
                        cityName   : data.address?.city_name  || '',
                        stateName  : data.address?.state_name || '',
                    },
                    weightLossGoal: (() => {
                        const rawValue = data.weight_loss_goal || '';
                        const weight = parseInt(rawValue, 10);
                        if (isNaN(weight) || weight <= 0) {
                            return '';
                        } else if (weight >= 1 && weight <= 15) {
                            return '1-15lbs';
                        } else if (weight >= 16 && weight <= 50) {
                            return '16-50lbs';
                        } else {
                            return '51+lbs';
                        }
                    })(),
                    ...(ef_transaction_id_get && { everflow_transaction_id: ef_transaction_id_get })
                }
            };

            try {
                const response = await fetch('https://api.humecare.com/v1/onboarding/patient-starter', {
                    method  : 'POST',
                    headers : {
                        'accept'      : 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payloadOnLoad),
                });

                if (!response.ok) {
                    window.location.href = '/pages/quiz-3';
                    return;
                }
                const result = await response.json();
                if (result.redirectUrl) {
                    localStorage.setItem('quiz_checkout_url', result.redirectUrl);
                    localStorage.removeItem('current_step');
                    window.location.href = result.redirectUrl;
                    return;
                }
                window.location.href = '/pages/quiz-3';

            } catch (err) {
                sessionStorage.removeItem('patient_api_submitted');
                console.error('Submission failed:', err);
            }
          }
        }

        initPatientSubmit();
    }
      
    function fireStepPixel(stepName) {
        if (typeof window === 'undefined') return;
        const fn = window.cvg ?? (typeof cvg !== 'undefined' ? cvg : undefined);
        if (typeof fn !== 'function') return;
        fn({ method: 'set',   eventProperties: { page_title: stepName } });
        fn({ method: 'track', eventName: '$page_load', properties: { page_title: stepName } });
    }

    const initialStep = document.querySelector('[js-slide-quiz-main]:not(.hidden)');
    fireStepPixel(initialStep?.dataset.step || 'step_0');

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    } 

    const patientData = {
        firstName      : '',
        lastName       : '',
        email          : '',
        dateOfBirth    : '',
        gender         : null,
        weight         : null,
        height         : null,
        address        : {
            address    : '',
            address2   : '',
            zipCode    : '',
            cityName   : '',
            stateName  : '',
        },
        weightLossGoal : '',
        ...(ef_transaction_id_get && { everflow_transaction_id: ef_transaction_id_get })
    };

    class WeightPicker extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.min = parseInt(this.getAttribute('min')) || 0;
        this.max = parseInt(this.getAttribute('max')) || 100;
        this.value = parseInt(this.getAttribute('value')) || 30;
        this.isDragging = false;
        this.startX = 0;
        this.startValue = 0;
        this.pixelsPerUnit = 8;
      }

      connectedCallback() {
        this.renderStructure();
        this.cacheDOM();
        this.setupEvents();
        this.resizeCanvas();
      }

      renderStructure() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: flex; flex-direction: column; align-items: center; width: 100%; user-select: none; -webkit-user-select: none; }
            .display-container { display: flex; align-items: center; justify-content: center; gap: 12px; margin-bottom: 24px; }
            .arrow-indicator { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; background-color: #eaf6ed; border-radius: 50%; }
            .arrow-indicator svg { width: 16px; height: 16px; fill: #1b7a32; }
            .weight-number { font-size: 64px; font-weight: 700; color: #1a1a1a; line-height: 1; }
            .weight-unit { font-size: 20px; font-weight: 600; color: #929292; margin-top: 0; }
            .ruler-wrapper { position: relative; width: 100%; height: 90px; cursor: ew-resize; touch-action: pan-y; }
            canvas { width: 100%; height: 100%; display: block; }
          </style>
          <div class="display-container">
            <div class="arrow-indicator">
              <svg viewBox="0 0 24 24"><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
            </div>
            <div class="weight-number" id="num-display">${this.value}</div>
            <div class="weight-unit">lbs</div>
          </div>
          <div class="ruler-wrapper" id="ruler-container">
            <canvas id="ruler-canvas"></canvas>
          </div>
        `;
      }

      cacheDOM() {
        this.container = this.shadowRoot.getElementById('ruler-container');
        this.canvas = this.shadowRoot.getElementById('ruler-canvas');
        this.ctx = this.canvas.getContext('2d');
        this.numDisplay = this.shadowRoot.getElementById('num-display');
      }

      setupEvents() {
        const onStart = (clientX) => {
          this.isDragging = true;
          this.startX = clientX;
          this.startValue = this.value;
        };

        const onMove = (clientX) => {
          if (!this.isDragging) return;
          
          const deltaX = clientX - this.startX;
          const valueOffset = deltaX / this.pixelsPerUnit;
          
          let newValue = Math.round(this.startValue - valueOffset);
          
          newValue = Math.max(this.min, Math.min(this.max, newValue));
          
          if (newValue !== this.value) {
            this.value = newValue;
            this.numDisplay.textContent = this.value;
            requestAnimationFrame(() => this.drawRuler());
          }
        };

        const onEnd = () => {
          this.isDragging = false;
        };

        this.container.addEventListener('mousedown', (e) => onStart(e.clientX));
        window.addEventListener('mousemove', (e) => onMove(e.clientX));
        window.addEventListener('mouseup', onEnd);

        this.container.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), { passive: true });
        window.addEventListener('touchmove', (e) => {
          if (this.isDragging) onMove(e.touches[0].clientX);
        }, { passive: true });
        window.addEventListener('touchend', onEnd);

        const resizeObserver = new ResizeObserver(() => this.resizeCanvas());
        resizeObserver.observe(this.container);
      }

      resizeCanvas() {
        const rect = this.container.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        this.canvas.width = rect.width * dpr;
        this.canvas.height = rect.height * dpr;
        this.ctx.scale(dpr, dpr);
        this.drawRuler();
      }

      drawRuler() {
        const width = this.canvas.width / (window.devicePixelRatio || 1);
        const height = this.canvas.height / (window.devicePixelRatio || 1);
        const ctx = this.ctx;
        ctx.clearRect(0, 0, width, height);
        const centerX = width / 2;

        for (let i = this.min; i <= this.max; i++) {
          const x = centerX + (i - this.value) * this.pixelsPerUnit;
          if (x < -20 || x > width + 20) continue;
          const isMajor = i % 10 === 0;
          const isMedium = i % 5 === 0 && !isMajor;
          let opacity = 1;
          const edgeThreshold = 80;
          if (x < edgeThreshold) opacity = x / edgeThreshold;
          if (x > width - edgeThreshold) opacity = (width - x) / edgeThreshold;
          opacity = Math.max(0, Math.min(1, opacity));

          if (isMajor) {
            ctx.strokeStyle = `rgba(38, 38, 38, ${opacity * 0.8})`;
            ctx.lineWidth = 1.5;
            ctx.beginPath();
            ctx.moveTo(x, 15);
            ctx.lineTo(x, 45);
            ctx.stroke();

            ctx.fillStyle = `rgba(146, 146, 146, ${opacity})`;
            ctx.font = '500 13px sans-serif';
            ctx.textAlign = 'center';
            ctx.fillText(i.toString(), x, 65);
          } else {
            ctx.strokeStyle = isMedium ? `rgba(160, 160, 160, ${opacity * 0.5})` : `rgba(210, 210, 210, ${opacity * 0.4})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(x, 23);
            ctx.lineTo(x, 37);
            ctx.stroke();
          }
        }
        ctx.strokeStyle = '#1a1a1a';
        ctx.lineWidth = 2.5;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(centerX, 2);
        ctx.lineTo(centerX, 50);
        ctx.stroke();
      }
    }
    customElements.define('weight-picker', WeightPicker);

    class MuscleSliderParametric extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.TIERS = [
          { key: 'soft', name: 'Soft', desc: "I've always been on the weaker side" },
          { key: 'average', name: 'Average', desc: 'Normal strength for my size' },
          { key: 'solid', name: 'Solid', desc: 'Stronger than most people I know' },
          { key: 'strong', name: 'Strong', desc: 'People are surprised how strong I am' }
        ];
        this.currentTier = -1;
        this.interacted = false;
        this.dragging = false;
        this.snapRAF = null;
        this.drawRAF = null;
        this.pendingT = null;
        this.SKIN = {
          base1: '#eebd97', base2: '#d89e74', base3: '#bd8057',
          deep: '#96603c', hi: '#fadfc2', vein: '#8d6f86'
        };
      }

      connectedCallback() {
        this.renderStructure();
        this.initComponent();
      }

      lerp(a, b, t) { return a + (b - a) * t; }
      ease(t) { return t * t * (3 - 2 * t); }
      tierFromValue(v) { return Math.max(0, Math.min(3, Math.round(v / 33.3333))); }
      tierCenter(tier) { return [0, 33.3333, 66.6667, 100][tier]; }

      generateArmSVG(t, defsId = 'sf') {
        const e = this.ease(t);
        const upperW   = this.lerp(36, 54, e);
        const bicepRise= this.lerp(7, 56, e);
        const deltRise = this.lerp(5, 26, e);
        const grooveD  = this.lerp(0, 9, e);
        const triSag   = this.lerp(3, 16, e);
        const foreW    = this.lerp(34, 52, e);
        const fistR    = this.lerp(22, 26, e);
        const defOp    = Math.max(0, (e - 0.32) / 0.68);
        const veinOp   = Math.max(0, (e - 0.8) / 0.2);
        const cy = 170;
        const top = cy - upperW * 0.5, bot = cy + upperW * 0.5;
        const neck   = { x: 46, y: top + 6 };
        const deltA  = { x: 84, y: top - deltRise };
        const groove = { x: this.lerp(112, 108, e), y: top - grooveD };
        const peakX  = this.lerp(152, 156, e);
        const peak   = { x: peakX, y: top - bicepRise };
        const crook  = { x: 212, y: cy - this.lerp(10, 4, e) };
        const elbow = { x: 236, y: cy + 4 }, wrist = { x: 190, y: 66 };
        const fdx = wrist.x - elbow.x, fdy = wrist.y - elbow.y, flen = Math.hypot(fdx, fdy);
        const fux = fdx / flen, fuy = fdy / flen, fnx = -fuy, fny = fux;
        const wIn  = { x: wrist.x - fnx * foreW * 0.40, y: wrist.y - fny * foreW * 0.40 };
        const wOut = { x: wrist.x + fnx * foreW * 0.44, y: wrist.y + fny * foreW * 0.44 };
        const brachX = elbow.x + fux * flen * 0.30 + fnx * (foreW * 0.85);
        const brachY = elbow.y + fuy * flen * 0.30 + fny * (foreW * 0.85);
        const fist   = { x: wrist.x + fux * (fistR * 0.42), y: wrist.y + fuy * (fistR * 0.42) };
        const sil = `M ${neck.x} ${neck.y}
          C ${neck.x + 8} ${deltA.y + 2} ${deltA.x - 18} ${deltA.y} ${deltA.x} ${deltA.y}
          C ${deltA.x + 14} ${deltA.y} ${groove.x - 8} ${groove.y} ${groove.x} ${groove.y}
          C ${groove.x + 10} ${groove.y - this.lerp(2, 8, e)} ${peak.x - 30} ${peak.y} ${peak.x} ${peak.y}
          C ${peak.x + 26} ${peak.y} ${crook.x - 10} ${crook.y - this.lerp(4, 26, e)} ${crook.x} ${crook.y}
          C ${crook.x + 2 - fnx * foreW * 0.16} ${crook.y + 8 - fny * foreW * 0.16} ${wIn.x + 6 - fnx * foreW * 0.10} ${wIn.y + 20 - fny * foreW * 0.10} ${wIn.x} ${wIn.y}
          L ${wOut.x} ${wOut.y}
          C ${brachX} ${brachY} ${elbow.x + foreW * 0.50} ${elbow.y - 6} ${elbow.x + 10} ${elbow.y + 12}
          C ${elbow.x + 6} ${bot + 8} ${elbow.x - 8} ${bot + 8} ${elbow.x - 22} ${bot + 6}
          C ${190} ${bot + triSag + 6} ${118} ${bot + triSag + 4} ${74} ${bot + 2}
          C ${52} ${bot} ${40} ${cy + 10} ${neck.x - 6} ${cy - 2}
          C ${40} ${cy - 12} ${42} ${neck.y + 6} ${neck.x} ${neck.y} Z`;
        const P = [];
        P.push(`<defs>
          <linearGradient id="skin_${defsId}" x1="0" y1="0" x2="0.25" y2="1">
            <stop offset="0%" stop-color="${this.SKIN.base1}"/>
            <stop offset="58%" stop-color="${this.SKIN.base2}"/>
            <stop offset="100%" stop-color="${this.SKIN.base3}"/>
          </linearGradient>
          <radialGradient id="bicepHi_${defsId}" cx="0.42" cy="0.32" r="0.75">
            <stop offset="0%" stop-color="${this.SKIN.hi}" stop-opacity="0.95"/>
            <stop offset="55%" stop-color="${this.SKIN.base1}" stop-opacity="0.5"/>
            <stop offset="100%" stop-color="${this.SKIN.base1}" stop-opacity="0"/>
          </radialGradient>
          <radialGradient id="deltHi_${defsId}" cx="0.45" cy="0.3" r="0.8">
            <stop offset="0%" stop-color="${this.SKIN.hi}" stop-opacity="0.7"/>
            <stop offset="100%" stop-color="${this.SKIN.hi}" stop-opacity="0"/>
          </radialGradient>
          <clipPath id="clip_${defsId}"><path d="${sil}"/></clipPath>
          <filter id="soft_${defsId}" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="5"/></filter>
          <filter id="soft2_${defsId}" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="3"/></filter>
        </defs>`);

        P.push(`<ellipse cx="155" cy="${bot + triSag + 16}" rx="${112 + e * 14}" ry="8" fill="#000" opacity="0.07"/>`);
        P.push(`<path d="${sil}" fill="url(#skin_${defsId})"/>`);
        P.push(`<g clip-path="url(#clip_${defsId})">`);

        const bcy = peak.y + bicepRise * 0.42 + 8;
        P.push(`<ellipse cx="${peak.x - this.lerp(26, 6, e)}" cy="${bcy}" rx="${this.lerp(58, 40, 0) + e * 18}" ry="${14 + bicepRise * 0.5}" opacity="${0.45 + e * 0.55}" fill="url(#bicepHi_${defsId})"/>`);
        P.push(`<ellipse cx="${deltA.x - 2}" cy="${deltA.y + 16}" rx="${26 + e * 10}" ry="${18 + e * 8}" opacity="${0.25 + e * 0.75}" fill="url(#deltHi_${defsId})"/>`);
        
        P.push(`<path filter="url(#soft2_${defsId})" fill="none" stroke="${this.SKIN.hi}" stroke-width="${6 + e * 5}" stroke-linecap="round" opacity="${0.4 + e * 0.2}"
          d="M ${elbow.x + fux * 16 + fnx * foreW * 0.18} ${elbow.y + fuy * 16 + fny * foreW * 0.18}
            C ${elbow.x + fux * flen * 0.4 + fnx * foreW * 0.22} ${elbow.y + fuy * flen * 0.4 + fny * foreW * 0.22}
              ${wrist.x - fux * 20 + fnx * 2} ${wrist.y - fuy * 20 + fny * 2} ${wrist.x - fux * 4} ${wrist.y - fuy * 4}"/>`);

        P.push(`<path filter="url(#soft_${defsId})" fill="${this.SKIN.base3}" opacity="${0.45}"
          d="M 60 ${bot - 6} C 120 ${bot + triSag + 8} 190 ${bot + triSag + 8} ${elbow.x + 8} ${bot - 2}
            L ${elbow.x + 10} ${bot + 12} C 180 ${bot + triSag + 18} 110 ${bot + triSag + 16} 58 ${bot + 8} Z"/>`);
        P.push(`<path filter="url(#soft_${defsId})" fill="${this.SKIN.base3}" opacity="${0.30 + defOp * 0.25}"
          d="M ${peak.x + 18} ${cy - upperW * 0.1} C ${crook.x - 8} ${crook.y + 6} ${crook.x} ${crook.y + 4} ${crook.x+6} ${crook.y+10}
            C ${crook.x - 4} ${cy + 8} ${peak.x + 30} ${cy + 6} ${peak.x + 18} ${cy - upperW * 0.1} Z"/>`);
        P.push(`<path filter="url(#soft2_${defsId})" fill="none" stroke="${this.SKIN.base3}" stroke-width="7" stroke-linecap="round" opacity="0.35"
          d="M ${crook.x + 2} ${crook.y + 4} C ${wIn.x + 8} ${wIn.y + 24} ${wIn.x + 4} ${wIn.y + 12} ${wIn.x + 1} ${wIn.y + 2}"/>`);

        P.push(`<path fill="none" filter="url(#soft2_${defsId})" stroke="${this.SKIN.deep}" stroke-width="3" stroke-linecap="round" opacity="${0.18 + defOp * 0.42}"
          d="M ${groove.x - 2} ${groove.y + 4} C ${groove.x + 2} ${cy - upperW * 0.1} ${groove.x - 4} ${cy+6} ${groove.x - 12} ${cy + upperW * 0.34}"/>`);
        P.push(`<path fill="none" filter="url(#soft2_${defsId})" stroke="${this.SKIN.deep}" stroke-width="2.5" stroke-linecap="round" opacity="${defOp * 0.38}"
          d="M ${groove.x + 12} ${cy + upperW * 0.22} C ${peak.x} ${cy + upperW * 0.30} ${crook.x - 26} ${cy + upperW * 0.26} ${crook.x - 6} ${cy + upperW * 0.14}"/>`);
        P.push(`<path fill="none" filter="url(#soft2_${defsId})" stroke="${this.SKIN.deep}" stroke-width="2.8" stroke-linecap="round" opacity="${0.25 + defOp * 0.3}"
          d="M ${crook.x + 2} ${crook.y + 8} Q ${elbow.x - 4} ${elbow.y} ${elbow.x + 4} ${elbow.y + 12}"/>`);
        P.push(`<path fill="none" filter="url(#soft2_${defsId})" stroke="${this.SKIN.deep}" stroke-width="2.2" stroke-linecap="round" opacity="${defOp * 0.32}"
          d="M ${elbow.x + fux * 26 - fnx * 3} ${elbow.y + fuy * 26 - fny * 3}
            C ${elbow.x + fux * flen * 0.55 - fnx * 5} ${elbow.y + fuy * flen * 0.55 - fny * 5}
              ${wrist.x - fux * 22} ${wrist.y - fuy * 22} ${wrist.x - fux * 10 - fnx * 2} ${wrist.y - fuy * 10 - fny * 2}"/>`);

        if (veinOp > 0.01) {
          P.push(`<path filter="url(#soft2_${defsId})" fill="none" stroke="${this.SKIN.vein}" stroke-width="1.8" stroke-linecap="round" opacity="${(veinOp * 0.35).toFixed(2)}"
            d="M ${peak.x - 12} ${peak.y + 8}
              C ${peak.x + 12} ${peak.y + 6} ${peak.x + 26} ${peak.y + bicepRise * 0.45} ${peak.x + 30} ${peak.y + bicepRise * 0.75}"/>`);
        }
        P.push(`</g>`);

        const fang = Math.atan2(fuy, fux) * 180 / Math.PI;
        const kn = [];
        for (let k = 0; k < 3; k++) {
          const kx = fist.x + fux * fistR * 0.72 + fnx * fistR * (k - 1.05) * 0.46;
          const ky = fist.y + fuy * fistR * 0.72 + fny * fistR * (k - 1.05) * 0.46;
          kn.push(`<circle cx="${kx.toFixed(1)}" cy="${ky.toFixed(1)}" r="${(fistR * 0.28).toFixed(1)}" fill="url(#skin_${defsId})"/>`);
        }
        P.push(`<g>
          <ellipse cx="${fist.x.toFixed(1)}" cy="${fist.y.toFixed(1)}" rx="${(fistR * 1.0).toFixed(1)}" ry="${(fistR * 0.9).toFixed(1)}"
            transform="rotate(${(fang + 90).toFixed(0)} ${fist.x.toFixed(1)} ${fist.y.toFixed(1)})" fill="url(#skin_${defsId})"/>
          ${kn.join('')}
          <path fill="none" stroke="${this.SKIN.base3}" stroke-width="1.8" stroke-linecap="round" opacity="0.45"
            d="M ${(fist.x - fnx * fistR * 0.55 + fux * fistR * 0.35).toFixed(1)} ${(fist.y - fny * fistR * 0.55 + fuy * fistR * 0.35).toFixed(1)}
              Q ${(fist.x - fnx * fistR * 0.15 - fux * fistR * 0.1).toFixed(1)} ${(fist.y - fny * fistR * 0.15 - fuy * fistR * 0.1).toFixed(1)}
                ${(fist.x - fnx * fistR * 0.50 - fux * fistR * 0.55).toFixed(1)} ${(fist.y - fny * fistR * 0.50 - fuy * fistR * 0.55).toFixed(1)}"/>
        </g>`);

        return `<svg viewBox="0 24 320 216" xmlns="http://www.w3.org/2000/svg">${P.join('\n')}</svg>`;
      }

      renderStructure() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: block; width: 100%; font-family: inherit; background: #ffffff; padding: 0; border-radius: 0; box-shadow: none; }
            .sf-card { display: flex; flex-direction: column; align-items: center; }
            .sf-stage { width: 100%; height: auto; min-height: 216px; }
            .sf-tier { text-align: center; margin: 0 0 14px; min-height: auto; transition: opacity 0.12s ease; }
            .sf-tier.sf-fading { opacity: 0; }
            .sf-tier-name { font-size: 24px; letter-spacing: -0.01em; font-weight: 700; color: #111111; transition: opacity .18s ease; line-height: 1.21; }
            .sf-tier-desc { margin-top: 3px; font-size: 13.5px; color: #5d6b68; transition: opacity .18s ease; line-height: 1.21; }
            .sf-slider-wrap { width: 100%; margin-top: 0; }
            .sf-range { -webkit-appearance: none; width: 100%; height: 8px; border-radius: 10px; background: #ececec; outline: none; background-image: linear-gradient(#000000, #000000); background-repeat: no-repeat; }
            .sf-range::-webkit-slider-thumb { -webkit-appearance: none; width: 28px; height: 28px; border-radius: 50%; background: #fff; border: 3px solid #000; cursor: pointer; box-shadow: 0 2px 6px rgba(0,0,0,0.15); transition: transform 0.1s; }
            .sf-range::-webkit-slider-thumb:active { transform: scale(1.2); }
            .sf-ticks { display: flex; justify-content: space-between; margin-top: 10px; }
            .sf-tick { font-size: 12px; color: #9aa7a4; cursor: pointer; transition: color 0.2s, font-weight 0.2s; font-weight: 600; }
            .sf-tick.active { color: #111111; }
            svg.sf-pulse { animation: sfPulse 0.3s ease-out; }
            @keyframes sfPulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.02); }
              100% { transform: scale(1); }
            }
          </style>
          <div class="sf-card">
            <div class="sf-stage" id="sfStage" aria-hidden="true"></div>
            <div class="sf-tier">
              <div class="sf-tier-name" id="sfTierName">Average</div>
              <div class="sf-tier-desc" id="sfTierDesc">Normal strength for my size</div>
            </div>
            <div class="sf-slider-wrap">
              <input type="range" class="sf-range" id="sfRange" min="0" max="100" value="33.3333" step="0.1">
              <div class="sf-ticks">
                <div class="sf-tick" data-tier="0">Soft</div>
                <div class="sf-tick" data-tier="1">Average</div>
                <div class="sf-tick" data-tier="2">Solid</div>
                <div class="sf-tick" data-tier="3">Strong</div>
              </div>
            </div>
          </div>
        `;
      }

      initComponent() {
        this.stage = this.shadowRoot.getElementById('sfStage');
        this.range = this.shadowRoot.getElementById('sfRange');
        this.tierBox = this.shadowRoot.querySelector('.sf-tier');
        this.tierName = this.shadowRoot.getElementById('sfTierName');
        this.tierDesc = this.shadowRoot.getElementById('sfTierDesc');
        this.ticks = Array.from(this.shadowRoot.querySelectorAll('.sf-tick'));

        this.range.addEventListener('input', () => {
          if (this.snapRAF) cancelAnimationFrame(this.snapRAF);
          this.interacted = true;
          this.renderUI(true);
        });

        this.range.addEventListener('change', () => this.snapToTier());
        this.range.addEventListener('pointerdown', () => { this.dragging = true; });

        ['pointerup', 'pointercancel', 'touchend', 'mouseup'].forEach(ev => {
          window.addEventListener(ev, () => {
            if (this.dragging) {
              this.dragging = false;
              this.snapToTier();
            }
          });
        });

        this.range.addEventListener('blur', () => this.snapToTier());

        this.range.addEventListener('keydown', (ev) => {
          var dir = (ev.key === 'ArrowRight' || ev.key === 'ArrowUp') ? 1 :
                    (ev.key === 'ArrowLeft' || ev.key === 'ArrowDown') ? -1 : 0;
          if (!dir) return;
          ev.preventDefault();
          this.interacted = true;
          var tier = Math.max(0, Math.min(3, this.tierFromValue(+this.range.value) + dir));
          this.range.value = this.tierCenter(tier);
          this.renderUI(true);
          this.emitAnswer();
        });

        this.ticks.forEach(el => {
          el.addEventListener('click', () => {
            this.interacted = true;
            this.range.value = this.tierCenter(+el.dataset.tier);
            this.renderUI(true);
            this.emitAnswer();
          });
        });

        this.renderUI(false);
      }

      setTierUI(tier, animate) {
        if (tier === this.currentTier) return;
        this.currentTier = tier;
        
        this.ticks.forEach(el => {
          el.classList.toggle('active', +el.dataset.tier === tier);
        });

        if (animate) {
          this.tierBox.classList.add('sf-fading');
          setTimeout(() => {
            this.tierName.textContent = this.TIERS[tier].name;
            this.tierDesc.textContent = this.TIERS[tier].desc;
            this.tierBox.classList.remove('sf-fading');
          }, 120);

          var svg = this.stage.querySelector('svg');
          if (svg) {
            svg.classList.remove('sf-pulse');
            void svg.getBoundingClientRect();
            svg.classList.add('sf-pulse');
          }
        } else {
          this.tierName.textContent = this.TIERS[tier].name;
          this.tierDesc.textContent = this.TIERS[tier].desc;
        }
      }

      paintArm(t) {
        this.pendingT = t;
        if (this.drawRAF) return;
        this.drawRAF = requestAnimationFrame(() => {
          this.drawRAF = null;
          var hadPulse = this.stage.querySelector('svg.sf-pulse');
          this.stage.innerHTML = this.generateArmSVG(this.pendingT, 'sf');
          if (hadPulse) this.stage.querySelector('svg').classList.add('sf-pulse');
        });
      }

      renderUI(animateTier) {
        var v = +this.range.value;
        this.range.style.setProperty('--fill', v + '%');
        this.range.style.backgroundSize = `${v}% 100%`;
        this.paintArm(v / 100);
        this.setTierUI(this.tierFromValue(v), animateTier);
      }

      snapToTier() {
        var target = this.tierCenter(this.tierFromValue(+this.range.value));
        if (Math.abs(target - this.range.value) < 0.4) {
          this.range.value = target; this.renderUI(false); this.emitAnswer(); return;
        }
        if (this.snapRAF) cancelAnimationFrame(this.snapRAF);
        
        const step = () => {
          var v = +this.range.value;
          var next = v + (target - v) * 0.28;
          if (Math.abs(target - next) < 0.4) {
            this.range.value = target; this.renderUI(false); this.emitAnswer(); return;
          }
          this.range.value = next; this.renderUI(false);
          this.snapRAF = requestAnimationFrame(step);
        };
        this.snapRAF = requestAnimationFrame(step);
      }

      emitAnswer() {
        if (!this.interacted) return;
        var tier = this.tierFromValue(+this.range.value);
        var answer = { type: 'sf:answer', id: 'muscle_tier', value: tier, key: this.TIERS[tier].key, label: this.TIERS[tier].name };
        try { window.parent.postMessage(answer, '*'); } catch (e) {}
        document.dispatchEvent(new CustomEvent('sf:answer', { detail: answer }));
      }
    }
    customElements.define('muscle-slider-parametric', MuscleSliderParametric);

    class SparkleEffect {
      constructor(canvas, ctx) {
        this.canvas = canvas;
        this.ctx = ctx;
        this.particles = [];
        this.animationId = null;
        this.burstComplete = false;
      }

      _drawSparkle(x, y, radius, opacity) {
        this.ctx.save();
        this.ctx.translate(x, y);
        this.ctx.rotate(Math.random() * Math.PI * 2);
        const gradient = this.ctx.createRadialGradient(0, 0, 0, 0, 0, radius);
        gradient.addColorStop(0, `rgba(255, 255, 255, ${opacity})`);
        gradient.addColorStop(0.5, `rgba(255, 223, 107, ${opacity * 0.8})`);
        gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
        this.ctx.fillStyle = gradient;
        this.ctx.beginPath();
        const points = 4;
        for (let i = 0; i < points * 2; i++) {
          const angle = (Math.PI / points) * i;
          const r = i % 2 === 0 ? radius : radius * 0.3;
          const px = Math.cos(angle) * r;
          const py = Math.sin(angle) * r;
          if (i === 0) this.ctx.moveTo(px, py);
          else this.ctx.lineTo(px, py);
        }
        this.ctx.closePath();
        this.ctx.fill();
        this.ctx.restore();
      }

      _createParticle() {
        const angle = Math.random() * Math.PI * 2;
        const speed = 1.5 + Math.random() * 3;
        return {
          x: this.canvas.width / 2,
          y: this.canvas.height / 2,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: 4 + Math.random() * 8,
          maxRadius: 10 + Math.random() * 5,
          opacity: 0.8 + Math.random() * 0.2,
          growth: 0.05 + Math.random() * 0.05,
          fade: 0.005 + Math.random() * 0.015,
          life: 0
        };
      }

      triggerBurst() {
        if (this.burstComplete) return;
        cancelAnimationFrame(this.animationId);
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.particles = [];
        const initialCount = 40;
        for (let i = 0; i < initialCount; i++) {
            this.particles.push(this._createParticle());
        }
        this._animate();
      }

      _animate() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.globalCompositeOperation = 'source-over';
        this.particles.forEach((p, index) => {
          this._drawSparkle(p.x, p.y, p.radius, p.opacity);
          p.x += p.vx;
          p.y += p.vy;
          p.radius += p.growth;
          if (p.radius > p.maxRadius) p.growth = -p.growth * 0.8;
          p.opacity -= p.fade;
          p.life++;
          if (p.opacity <= 0 || p.radius < 0.1 || p.life > 180) {
            this.particles.splice(index, 1);
          }
        });
        
        if (this.particles.length > 0) {
          this.animationId = requestAnimationFrame(() => this._animate());
        } else {
          this.burstComplete = true;
        }
      }
    }
    
    class HeightPicker extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.currentCm = parseInt(this.getAttribute('value-cm')) || 170; 
        this.unit = 'ft'; 
        this.isDragging = false;
        this.startX = 0;
        this.startCm = 0;
        this.minCm = 90;   
        this.maxCm = 300;  
      }

      get value() {
        const totalInches = this.currentCm / 2.54;
        let feet = Math.floor(totalInches / 12);
        let inches = Math.round(totalInches % 12);
        if (inches === 12) { feet += 1; inches = 0; }
        return {
          unit: this.unit,
          cm: this.currentCm,
          ft: feet,
          in: inches,
          formatted: this.unit === 'cm' ? `${this.currentCm} cm` : `${feet} ft ${inches} in`
        };
      }

      connectedCallback() {
        this.renderStructure();
        this.cacheDOM();
        this.setupEvents();
        this.updateDisplay();
        
        setTimeout(() => {
          this.resizeCanvas();
        }, 50);
      }

      renderStructure() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: flex; flex-direction: column; align-items: center; width: 100%; user-select: none; -webkit-user-select: none; }
            .label-title { font-size: 14px; color: #929292; font-weight: 500; margin-bottom: 8px; }
            .height-display { font-size: 56px; font-weight: 700; color: #1a1a1a; margin-bottom: 20px; height: 68px; display: flex; align-items: center; justify-content: center; gap:6px;  }
            .toggle-container { display: flex; border: 1px solid #1a1a1a; border-radius: 4px; overflow: hidden; margin-bottom: 30px; width: 160px; height: 36px; }
            .toggle-btn { flex: 1; border: none; background: #ffffff; color: #1a1a1a; font-size: 14px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; }
            .toggle-btn.active { background: #1a1a1a; color: #ffffff; }
            .ruler-wrapper { position: relative; width: 100%; height: 100px; cursor: ew-resize; touch-action: none; }
            canvas { width: 100%; height: 100%; display: block; }
          </style>
          <div class="label-title">Height</div>
          <div class="height-display" id="height-text">--</div>
          <div class="toggle-container">
            <button class="toggle-btn" id="btn-cm">cm</button>
            <button class="toggle-btn active" id="btn-ft">ft / in</button>
          </div>
          <div class="ruler-wrapper" id="ruler-container">
            <canvas id="ruler-canvas"></canvas>
          </div>
        `;
      }

      cacheDOM() {
        this.container = this.shadowRoot.getElementById('ruler-container');
        this.canvas = this.shadowRoot.getElementById('ruler-canvas');
        this.ctx = this.canvas.getContext('2d');
        this.heightText = this.shadowRoot.getElementById('height-text');
        this.btnCm = this.shadowRoot.getElementById('btn-cm');
        this.btnFt = this.shadowRoot.getElementById('btn-ft');
      }

      setupEvents() {
        this.btnCm.addEventListener('click', () => this.setUnit('cm'));
        this.btnFt.addEventListener('click', () => this.setUnit('ft'));

        this.container.addEventListener('pointerdown', (e) => {
          this.isDragging = true;
          this.startX = e.clientX;
          this.startCm = this.currentCm;
          this.container.setPointerCapture(e.pointerId);
        });

        this.container.addEventListener('pointermove', (e) => {
          if (!this.isDragging) return;
          const deltaX = e.clientX - this.startX;
          let cmOffset = this.unit === 'cm' ? deltaX / 8 : (deltaX / 14) * 2.54;

          let newCm = Math.round(this.startCm - cmOffset);
          newCm = Math.max(this.minCm, Math.min(this.maxCm, newCm));

          if (newCm !== this.currentCm) {
            this.currentCm = newCm;
            this.updateDisplay();
            this.dispatchEvent(new CustomEvent('height-change', { detail: this.value, bubbles: true, composed: true }));
            requestAnimationFrame(() => this.drawRuler());
          }
        });

        const onEnd = (e) => {
          if (this.isDragging) {
            this.isDragging = false;
            this.container.releasePointerCapture(e.pointerId);
          }
        };

        this.container.addEventListener('pointerup', onEnd);
        this.container.addEventListener('pointercancel', onEnd);

        new ResizeObserver(() => this.resizeCanvas()).observe(this.container);
      }

      setUnit(targetUnit) {
        if (this.unit === targetUnit) return;
        this.unit = targetUnit;
        this.btnCm.classList.toggle('active', this.unit === 'cm');
        this.btnFt.classList.toggle('active', this.unit === 'ft');
        this.updateDisplay();
        this.drawRuler();
      }

      updateDisplay() {
        if (this.unit === 'cm') {
          this.heightText.innerHTML = `${this.currentCm} <span>cm</span>`;
        } else {
          const totalInches = this.currentCm / 2.54;
          let feet = Math.floor(totalInches / 12);
          let inches = Math.round(totalInches % 12);
          if (inches === 12) { feet += 1; inches = 0; }
          this.heightText.innerHTML = `${feet} <span>ft</span> ${inches} <span>in</span>`;
        }
      }

      resizeCanvas() {
        const rect = this.container.getBoundingClientRect();
        if (rect.width === 0) return;
        const dpr = window.devicePixelRatio || 1;
        this.canvas.width = rect.width * dpr;
        this.canvas.height = rect.height * dpr;
        this.ctx.scale(dpr, dpr);
        this.drawRuler();
      }

      drawRuler() {
        const width = this.canvas.width / (window.devicePixelRatio || 1);
        const height = this.canvas.height / (window.devicePixelRatio || 1);
        const ctx = this.ctx;
        ctx.clearRect(0, 0, width, height);
        const centerX = width / 2;

        if (this.unit === 'cm') {
          const pxPerCm = 8;
          for (let i = this.minCm; i <= this.maxCm; i++) {
            const x = centerX + (i - this.currentCm) * pxPerCm;
            if (x < -30 || x > width + 30) continue;
            let opacity = Math.max(0, Math.min(1, x < 80 ? x / 80 : (width - x) / 80));
            if (i % 10 === 0) {
              ctx.strokeStyle = `rgba(26, 26, 26, ${opacity * 0.8})`;
              ctx.lineWidth = 1.5;
              ctx.beginPath(); ctx.moveTo(x, 25); ctx.lineTo(x, 60); ctx.stroke();
              ctx.fillStyle = `rgba(146, 146, 146, ${opacity})`;
              ctx.font = '500 13px sans-serif'; ctx.textAlign = 'center';
              ctx.fillText(`${i} cm`, x, 80);
            } else {
              ctx.strokeStyle = (i % 5 === 0) ? `rgba(146, 146, 146, ${opacity * 0.6})` : `rgba(210, 210, 210, ${opacity * 0.5})`;
              ctx.lineWidth = 1;
              ctx.beginPath(); ctx.moveTo(x, 32); ctx.lineTo(x, 52); ctx.stroke();
            }
          }
        } else {
          const pxPerInch = 14;
          const minInch = Math.floor(this.minCm / 2.54);
          const maxInch = Math.ceil(this.maxCm / 2.54);
          const currentTotalInches = this.currentCm / 2.54;

          for (let i = minInch; i <= maxInch; i++) {
            const x = centerX + (i - currentTotalInches) * pxPerInch;
            if (x < -30 || x > width + 30) continue;
            let opacity = Math.max(0, Math.min(1, x < 80 ? x / 80 : (width - x) / 80));
            if (i % 12 === 0) {
              ctx.strokeStyle = `rgba(26, 26, 26, ${opacity * 0.8})`;
              ctx.lineWidth = 1.5;
              ctx.beginPath(); ctx.moveTo(x, 25); ctx.lineTo(x, 60); ctx.stroke();
              ctx.fillStyle = `rgba(146, 146, 146, ${opacity})`;
              ctx.font = '600 13px sans-serif'; ctx.textAlign = 'center';
              ctx.fillText(`${i / 12} ft`, x, 80);
            } else {
              ctx.strokeStyle = `rgba(210, 210, 210, ${opacity * 0.6})`;
              ctx.lineWidth = 1;
              ctx.beginPath(); ctx.moveTo(x, 32); ctx.lineTo(x, 52); ctx.stroke();
            }
          }
        }
        ctx.fillStyle = '#1a1a1a'; ctx.fillRect(centerX - 4, 10, 8, 8);
        ctx.strokeStyle = '#1a1a1a'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(centerX, 18); ctx.lineTo(centerX, 64); ctx.stroke();
      }
    }
    customElements.define('height-picker', HeightPicker);

    class WeightUnitPicker extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.currentKg = parseFloat(this.getAttribute('value-kg')) || 75; 
        this.unit = 'lbs'; 
        this.isDragging = false;
        this.startX = 0;
        this.startKg = 0;
        this.minKg = 60 / 2.20462;   
        this.maxKg = 800 / 2.20462;  
      }

      get value() {
        const lbsValue = Math.round(this.currentKg * 2.20462);
        return {
          unit: this.unit,
          kg: Math.round(this.currentKg),
          lbs: lbsValue,
          currentSelectedValue: this.unit === 'kg' ? Math.round(this.currentKg) : lbsValue,
          formatted: this.unit === 'kg' ? `${Math.round(this.currentKg)} kg` : `${lbsValue} lbs`
        };
      }

      connectedCallback() {
        this.renderStructure();
        this.cacheDOM();
        this.setupEvents();
        this.updateDisplay();
        
        setTimeout(() => {
          this.resizeCanvas();
        }, 50);
      }

      renderStructure() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: flex; flex-direction: column; align-items: center; width: 100%; user-select: none; -webkit-user-select: none; }
            .label-title { font-size: 14px; color: #929292; font-weight: 500; margin-bottom: 8px; }
            .weight-display { font-size: 56px; font-weight: 700; color: #1a1a1a; margin-bottom: 20px; height: 68px; display: flex; align-items: center; justify-content: center; }
            .weight-display span { font-size: 24px; font-weight: 600; color: #929292; margin-left: 8px; }
            .toggle-container { display: flex; border: 1px solid #1a1a1a; border-radius: 4px; overflow: hidden; margin-bottom: 30px; width: 160px; height: 36px; }
            .toggle-btn { flex: 1; border: none; background: #ffffff; color: #1a1a1a; font-size: 14px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; }
            .toggle-btn.active { background: #1a1a1a; color: #ffffff; }
            .ruler-wrapper { position: relative; width: 100%; height: 100px; cursor: ew-resize; touch-action: none; }
            canvas { width: 100%; height: 100%; display: block; }
          </style>
          <div class="label-title">Current weight</div>
          <div class="weight-display" id="weight-text">--</div>
          <div class="toggle-container">
            <button class="toggle-btn" id="btn-kg">kg</button>
            <button class="toggle-btn active" id="btn-lbs">lbs</button>
          </div>
          <div class="ruler-wrapper" id="ruler-container">
            <canvas id="ruler-canvas"></canvas>
          </div>
        `;
      }

      cacheDOM() {
        this.container = this.shadowRoot.getElementById('ruler-container');
        this.canvas = this.shadowRoot.getElementById('ruler-canvas');
        this.ctx = this.canvas.getContext('2d');
        this.weightText = this.shadowRoot.getElementById('weight-text');
        this.btnKg = this.shadowRoot.getElementById('btn-kg');
        this.btnLbs = this.shadowRoot.getElementById('btn-lbs');
      }

      setupEvents() {
        this.btnKg.addEventListener('click', () => this.setUnit('kg'));
        this.btnLbs.addEventListener('click', () => this.setUnit('lbs'));

        this.container.addEventListener('pointerdown', (e) => {
          this.isDragging = true;
          this.startX = e.clientX;
          this.startKg = this.currentKg;
          this.container.setPointerCapture(e.pointerId);
        });

        this.container.addEventListener('pointermove', (e) => {
          if (!this.isDragging) return;
          const deltaX = e.clientX - this.startX;
          let kgOffset = this.unit === 'kg' ? deltaX / 10 : (deltaX / 7) / 2.20462;

          let newKg = this.startKg - kgOffset;
          newKg = Math.max(this.minKg, Math.min(this.maxKg, newKg));

          if (Math.abs(newKg - this.currentKg) > 0.05) {
            this.currentKg = newKg;
            this.updateDisplay();
            this.dispatchEvent(new CustomEvent('weight-change', { detail: this.value, bubbles: true, composed: true }));
            requestAnimationFrame(() => this.drawRuler());
          }
        });

        const onEnd = (e) => {
          if (this.isDragging) {
            this.isDragging = false;
            this.container.releasePointerCapture(e.pointerId);
            this.currentKg = Math.round(this.currentKg * (this.unit === 'kg' ? 1 : 2.20462)) / (this.unit === 'kg' ? 1 : 2.20462);
            this.updateDisplay();
            this.drawRuler();
          }
        };

        this.container.addEventListener('pointerup', onEnd);
        this.container.addEventListener('pointercancel', onEnd);

        new ResizeObserver(() => this.resizeCanvas()).observe(this.container);
      }

      setUnit(targetUnit) {
        if (this.unit === targetUnit) return;
        this.unit = targetUnit;
        this.btnKg.classList.toggle('active', this.unit === 'kg');
        this.btnLbs.classList.toggle('active', this.unit === 'lbs');
        this.updateDisplay();
        this.drawRuler();
      }

      updateDisplay() {
        if (this.unit === 'kg') {
          this.weightText.innerHTML = `${Math.round(this.currentKg)} <span>kg</span>`;
        } else {
          const lbsValue = Math.round(this.currentKg * 2.20462);
          this.weightText.innerHTML = `${lbsValue} <span>lbs</span>`;
        }
      }

      resizeCanvas() {
        const rect = this.container.getBoundingClientRect();
        if (rect.width === 0) return;
        const dpr = window.devicePixelRatio || 1;
        this.canvas.width = rect.width * dpr;
        this.canvas.height = rect.height * dpr;
        this.ctx.scale(dpr, dpr);
        this.drawRuler();
      }

      drawRuler() {
        const width = this.canvas.width / (window.devicePixelRatio || 1);
        const height = this.canvas.height / (window.devicePixelRatio || 1);
        const ctx = this.ctx;
        ctx.clearRect(0, 0, width, height);
        const centerX = width / 2;

        if (this.unit === 'kg') {
          const pxPerKg = 10;
          for (let i = Math.floor(this.minKg); i <= Math.ceil(this.maxKg); i++) {
            const x = centerX + (i - this.currentKg) * pxPerKg;
            if (x < -30 || x > width + 30) continue;
            let opacity = Math.max(0, Math.min(1, x < 80 ? x / 80 : (width - x) / 80));
            if (i % 10 === 0) {
              ctx.strokeStyle = `rgba(26, 26, 26, ${opacity * 0.8})`;
              ctx.lineWidth = 1.5;
              ctx.beginPath(); ctx.moveTo(x, 25); ctx.lineTo(x, 60); ctx.stroke();
              ctx.fillStyle = `rgba(146, 146, 146, ${opacity})`;
              ctx.font = '500 13px sans-serif'; ctx.textAlign = 'center';
              ctx.fillText(i.toString(), x, 80);
            } else {
              ctx.strokeStyle = (i % 5 === 0) ? `rgba(146, 146, 146, ${opacity * 0.6})` : `rgba(210, 210, 210, ${opacity * 0.5})`;
              ctx.lineWidth = 1;
              ctx.beginPath(); ctx.moveTo(x, 32); ctx.lineTo(x, 52); ctx.stroke();
            }
          }
        } else {
          const pxPerLbs = 7;
          const currentLbs = this.currentKg * 2.20462;
          const minLbs = Math.floor(this.minKg * 2.20462);
          const maxLbs = Math.ceil(this.maxKg * 2.20462);

          for (let i = minLbs; i <= maxLbs; i++) {
            const x = centerX + (i - currentLbs) * pxPerLbs;
            if (x < -30 || x > width + 30) continue;
            let opacity = Math.max(0, Math.min(1, x < 80 ? x / 80 : (width - x) / 80));
            if (i % 10 === 0) {
              ctx.strokeStyle = `rgba(26, 26, 26, ${opacity * 0.8})`;
              ctx.lineWidth = 1.5;
              ctx.beginPath(); ctx.moveTo(x, 25); ctx.lineTo(x, 60); ctx.stroke();
              ctx.fillStyle = `rgba(146, 146, 146, ${opacity})`;
              ctx.font = '500 13px sans-serif'; ctx.textAlign = 'center';
              ctx.fillText(i.toString(), x, 80);
            } else {
              ctx.strokeStyle = (i % 5 === 0) ? `rgba(146, 146, 146, ${opacity * 0.6})` : `rgba(210, 210, 210, ${opacity * 0.5})`;
              ctx.lineWidth = 1;
              ctx.beginPath(); ctx.moveTo(x, 32); ctx.lineTo(x, 52); ctx.stroke();
            }
          }
        }
        ctx.fillStyle = '#1a1a1a'; ctx.fillRect(centerX - 4, 10, 8, 8);
        ctx.strokeStyle = '#1a1a1a'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(centerX, 18); ctx.lineTo(centerX, 64); ctx.stroke();
      }
    }
    customElements.define('weight-unit-picker', WeightUnitPicker);

    class SeverityStepper extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.currentValue = parseInt(this.getAttribute('value')) || 5;
        this.min = 1;
        this.max = 10;
      }

      get value() {
        return this.currentValue;
      }

      connectedCallback() {
        this.render();
        this.cacheDOM();
        this.setupEvents();
        this.updateUI();
      }

      render() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: block; background: #ffffff; border-radius: 20px; box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04); padding: 32px 24px 24px 24px; box-sizing: border-box; width: 100%; user-select: none; -webkit-user-select: none; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
            .stepper-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 28px; padding: 0 12px; }
            .step-btn { width: 56px; height: 56px; border-radius: 50%; border: 1px solid #e5e5ea; background-color: #ffffff; display: flex; align-items: center; justify-content: center; cursor: pointer; outline: none; transition: all 0.2s ease; padding: 0; }
            .step-btn:active { background-color: #f5f5f7; transform: scale(0.94); }
            .step-btn svg { width: 16px; height: 16px; fill: #1c1c1e; transition: opacity 0.2s; }
            .step-btn:disabled { opacity: 0.3; cursor: not-allowed; background-color: #ffffff; transform: none; }
            .number-display { font-size: 64px; font-weight: 700; color: #1c1c1e; line-height: 1; min-width: 80px; text-align: center; }
            .labels-row { display: flex; justify-content: space-between; align-items: center; padding: 0 4px; }
            .info-label { font-size: 14px; font-weight: 600; color: #8e8e93; letter-spacing: -0.1px; }
          </style>
          <div class="stepper-row">
            <button class="step-btn" id="btnMinus" aria-label="Decrease severity">
              <svg viewBox="0 0 24 24"><path d="M19 13H5v-2h14v2z"/></svg>
            </button>
            <div class="number-display" id="numDisplay">--</div>
            <button class="step-btn" id="btnPlus" aria-label="Increase severity">
              <svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
            </button>
          </div>
          <div class="labels-row">
            <div class="info-label">1 • None</div>
            <div class="info-label">10 • Severe</div>
          </div>
        `;
      }

      cacheDOM() {
        this.btnMinus = this.shadowRoot.getElementById('btnMinus');
        this.btnPlus = this.shadowRoot.getElementById('btnPlus');
        this.numDisplay = this.shadowRoot.getElementById('numDisplay');
      }

      setupEvents() {
        this.btnMinus.addEventListener('click', () => {
          if (this.currentValue > this.min) {
            this.currentValue--;
            this.updateUI();
            this.triggerChange();
          }
        });

        this.btnPlus.addEventListener('click', () => {
          if (this.currentValue < this.max) {
            this.currentValue++;
            this.updateUI();
            this.triggerChange();
          }
        });
      }

      updateUI() {
        this.numDisplay.textContent = this.currentValue;
        this.btnMinus.disabled = this.currentValue <= this.min;
        this.btnPlus.disabled = this.currentValue >= this.max;
      }

      triggerChange() {
        this.dispatchEvent(new CustomEvent('change', {
          detail: { value: this.currentValue },
          bubbles: true,
          composed: true
        }));
      }
    }
    customElements.define('severity-stepper', SeverityStepper);

    class CustomRangeBar extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.min = parseInt(this.getAttribute('min')) || 0;
        this.max = parseInt(this.getAttribute('max')) || 100;
        this.currentValue = parseInt(this.getAttribute('value')) || this.min;
        this.unit = this.getAttribute('unit') || '';
        this.showMax = this.getAttribute('show-max') === 'true';
        this.isDragging = false;
      }

      connectedCallback() {
        this.render();
        this.cacheDOM();
        this.setupEvents();
        this.updateUI();
      }

      get value() { return this.currentValue; }
      set value(val) {
        this.currentValue = Math.max(this.min, Math.min(this.max, parseInt(val)));
        this.updateUI();
      }

      render() {
        this.shadowRoot.innerHTML = `

          <style>
            :host { display: block; width: 100%; user-select: none; -webkit-user-select: none; font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
            .display-wrapper { display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 36px; }
            .number-text { font-size: 64px; font-weight: 700; color: #1c1c1e; line-height: 1; }
            .unit-text { font-size: 16px; font-weight: 500; color: #aeaeb2; }
            .meta-text {color: #B0B0B0;}
            .slider-container { position: relative; padding: 12px 0; cursor: pointer; }
            .track-bg { height: 8px; background-color: #f2f2f7; border-radius: 48px; position: relative; width: 100%; }
            .track-fill { position: absolute; left: 0; top: 0; height: 100%; background-color: #1c1c1e; border-radius: 8px; width: 0%; }
            .thumb-knob { position: absolute; top: 50%; left: 0%; transform: translate(-50%, -50%); width: 28px; height: 28px; background-color: #1c1c1e; border-radius: 50%; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16); display: flex; align-items: center; justify-content: center; cursor: grab; touch-action: none; }
            .thumb-knob::after { content: ''; width: 10px; height: 10px; background-color: #ffffff; border-radius: 50%; }
            .thumb-knob:active { cursor: grabbing; transform: translate(-50%, -50%) scale(1.05); }
            .labels-container { display: flex; justify-content: space-between; margin-top: 14px; font-size: 14px; font-weight: 500; color: #c7c7cc; padding: 0 2px; }
          </style>

          <div class="display-wrapper">
            <div class="number-text" id="numDisplay">--</div>
            <div class="meta-text" id="metaDisplay"></div>
          </div>

          <div class="slider-container" id="sliderContainer">
            <div class="track-bg">
              <div class="track-fill" id="trackFill"></div>
              <div class="thumb-knob" id="thumbKnob"></div>
            </div>
          </div>

          <div class="labels-container">
            <div>${this.min}</div>
            <div>${this.max}</div>
          </div>
        `;
      }

      cacheDOM() {
        this.numDisplay = this.shadowRoot.getElementById('numDisplay');
        this.metaDisplay = this.shadowRoot.getElementById('metaDisplay');
        this.sliderContainer = this.shadowRoot.getElementById('sliderContainer');
        this.trackFill = this.shadowRoot.getElementById('trackFill');
        this.thumbKnob = this.shadowRoot.getElementById('thumbKnob');
      }

      setupEvents() {
        this.thumbKnob.addEventListener('pointerdown', (e) => this.startDrag(e));
        this.sliderContainer.addEventListener('pointerdown', (e) => {
          this.evaluatePosition(e);
          this.startDrag(e);
        });

        window.addEventListener('pointermove', (e) => this.onDrag(e));
        window.addEventListener('pointerup', () => this.endDrag());
      }

      startDrag(e) {
        this.isDragging = true;
        this.thumbKnob.setPointerCapture(e.pointerId);
      }

      onDrag(e) {
        if (!this.isDragging) return;
        this.evaluatePosition(e);
      }

      endDrag() {
        this.isDragging = false;
      }

      evaluatePosition(e) {
        const rect = this.sliderContainer.getBoundingClientRect();
        let posX = e.clientX - rect.left;
        let percentage = posX / rect.width;

        if (percentage < 0) percentage = 0;
        if (percentage > 1) percentage = 1;

        const calculatedValue = this.min + percentage * (this.max - this.min);
        this.currentValue = Math.round(calculatedValue);

        this.updateUI();
        this.dispatchChangeEvent();
      }

      updateUI() {
        this.numDisplay.textContent = this.currentValue;
        if (this.showMax) {
          this.metaDisplay.textContent = `/ ${this.max}`;
        } else {
          this.metaDisplay.textContent = this.unit;
        }
        const percentage = ((this.currentValue - this.min) / (this.max - this.min)) * 100;
        this.trackFill.style.width = `${percentage}%`;
        this.thumbKnob.style.left = `${percentage}%`;
      }

      dispatchChangeEvent() {
        this.dispatchEvent(new CustomEvent('change', {
          detail: { value: this.currentValue },
          bubbles: true,
          composed: true
        }));
      }
    }
    customElements.define('custom-range-bar', CustomRangeBar);    

    class CustomCircleProgress extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.targetValue = parseInt(this.getAttribute('max-value')) || 100;
        this.radius = 90;
        this.circumference = 2 * Math.PI * this.radius;
        this.hasAnimated = false;
        this.animationId = null; 
        this.isStopped = false;
      }

      connectedCallback() {
        this.render();
        this.cacheDOM();
        this.setupIntersectionObserver();
      }

      render() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: block; width: 100%; height: 100%; user-select: none; -webkit-user-select: none; }
            .slider-wrapper { position: relative; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
            svg { width: 100%; height: 100%; transform: rotate(-90deg); }
            .circle-bg { fill: none; stroke: #f2f2f7; stroke-width: 14px; }
            .circle-fill { fill: none; stroke: #1c1c1e; stroke-width: 14px; stroke-linecap: round; will-change: stroke-dashoffset; }
            .center-text-box { position: absolute; display: flex; align-items: center; justify-content: center; font-size: 40px; font-weight: 700; color: #1c1c1e; font-family: 'Inter'; }
          </style>
          <div class="slider-wrapper">
            <svg viewBox="0 0 200 200">
              <circle class="circle-bg" cx="100" cy="100" r="${this.radius}"></circle>
              <circle class="circle-fill" id="progressCircle" cx="100" cy="100" r="${this.radius}"></circle>
            </svg>
            <div class="center-text-box" id="textDisplay">0%</div>
          </div>
        `;
      }

      cacheDOM() {
        this.progressCircle = this.shadowRoot.getElementById('progressCircle');
        this.textDisplay = this.shadowRoot.getElementById('textDisplay');
        this.progressCircle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
        this.progressCircle.style.strokeDashoffset = this.circumference;
      }

      setupIntersectionObserver() {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.hasAnimated) {
              this.hasAnimated = true;
              setTimeout(() => {
                this.animateProgress();
              }, 300);
              observer.unobserve(this);
            }
          });
        }, { threshold: 0.5 });
        observer.observe(this);
      }

      animateProgress() {
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
        }
        this.isStopped = false;
        if (this.targetValue === 0) {
          this.handleAnimationComplete();
          return;
        }
        const duration = 6500;
        let startTime = null;
        
        const step = (timestamp) => {
          if (this.isStopped) return;

          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;
          let progressRatio = Math.min(elapsed / duration, 1);
          const easeRatio = 1 - Math.pow(1 - progressRatio, 3);
          const currentVal = Math.round(easeRatio * this.targetValue);
          
          this.textDisplay.textContent = `${currentVal}%`;
          const actualPercentRatio = currentVal / 100;
          const offset = this.circumference * (1 - actualPercentRatio);
          this.progressCircle.style.strokeDashoffset = offset;

          this.dispatchEvent(new CustomEvent('circle-progress-update', {
            detail: { value: currentVal },
            bubbles: true,
            composed: true
          }));

          if (progressRatio < 1) {
            this.animationId = requestAnimationFrame(step);
          } else {
            this.animationId = null;
            this.handleAnimationComplete();
          }
        };
        this.animationId = requestAnimationFrame(step);
      }

      stopAndReset() {
        this.isStopped = true;
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
          this.animationId = null;
        }
        this.hasAnimated = false;
        this.textDisplay.textContent = "0%";
        this.progressCircle.style.strokeDashoffset = this.circumference;
      }

      resetAndAnimate() {
        this.stopAndReset();
        this.hasAnimated = true;
        setTimeout(() => {
          this.animateProgress();
        }, 300);
      }

      handleAnimationComplete() {
        if (this.isStopped) return; 
        const completeEvent = new CustomEvent('circle-progress-complete', {
          bubbles: true,
          composed: true
        });
        this.dispatchEvent(completeEvent);
      }
    }
    customElements.define('custom-circle-progress', CustomCircleProgress);

    const statusTexts = [
      { max: 25, text: "Analysing your metabolic profile..." },
      { max: 50, text: "Reviewing clinical data for your age and body type..." },
      { max: 75, text: "Cross-referencing health history with eligibility criteria..." },
      { max: 100, text: "Building your personalized treatment plan..." }
    ];
    const textSpan = document.querySelector('.step_____thirty__two .quiz__optimize___step__para > span');
    document.addEventListener('circle-progress-update', (event) => {
      if (!textSpan) return;
      const currentPercent = event.detail.value;
      const matchedStep = statusTexts.find(step => currentPercent <= step.max);
      if (matchedStep && textSpan.textContent !== matchedStep.text) {
        textSpan.textContent = matchedStep.text;
      }
    });

    document.addEventListener('circle-progress-complete', () => {
      goToNextSlide();
    });

    class CustomDobPicker extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
      }

      connectedCallback() {
        this.render();
        this.cacheDOM();
        this.initMasking();
      }

      render() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: block; width: 100%; box-sizing: border-box; }
            .input-container { width: 100%; position: relative; display: flex; align-items: center; max-width: 320px; margin: 0 auto; }
            input { width: 100%; height: 56px; padding: 0 48px 0 16px; font-size: 24px; font-weight: 400; color: #1c1c1e; font-family: 'Inter', system-ui, -apple-system, sans-serif; text-align: center; background-color: #ffffff; border: 1px solid #b0b0b5; border-radius: 12px; box-sizing: border-box; outline: none; transition: border-color 0.2s ease, box-shadow 0.2s ease; }
            input:focus { border-color: #0a0a0a; box-shadow: 0 0 0 3px rgb(10 10 10 / 10%); }
            input:focus { stroke: #0a0a0a; }
            input::placeholder { color: #a9a9b0; opacity: 1; }
            .calendar-icon { position: absolute; right: 16px; display: flex; align-items: center; pointer-events: none; }
            .calendar-icon svg { width: 22px; height: 22px; stroke: #000; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; transition: stroke 0.2s ease; }
          </style>
          <div class="input-container">
            <input 
              type="text" 
              id="dobInput" 
              placeholder="mm/dd/yyyy" 
              inputmode="numeric" 
              maxlength="10" 
              autocomplete="off"
            >
            <div class="calendar-icon"><svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88" fill="none"> <g clip-path="url(#clip0_3958_256____dp)"> <path d="M76.9961 11H10.9961C8.07871 11 5.28081 12.1589 3.21791 14.2218C1.15501 16.2847 -0.00390625 19.0826 -0.00390625 22V77C-0.00390625 79.9174 1.15501 82.7153 3.21791 84.7782C5.28081 86.8411 8.07871 88 10.9961 88H76.9961C79.9135 88 82.7114 86.8411 84.7743 84.7782C86.8372 82.7153 87.9961 79.9174 87.9961 77V22C87.9961 19.0826 86.8372 16.2847 84.7743 14.2218C82.7114 12.1589 79.9135 11 76.9961 11ZM76.9961 77H10.9961V30.25H76.9961V77Z" fill="black"/> <path d="M14 8.9407e-08V11.4C14 13.4156 14.5268 15.3487 15.4645 16.774C16.4021 18.1993 17.6739 19 19 19C20.3261 19 21.5979 18.1993 22.5355 16.774C23.4732 15.3487 24 13.4156 24 11.4V8.9407e-08" fill="black"/> <path d="M64 -7.97215e-07V11.3972C64 13.4124 64.0036 16.9278 64.0051 19C65.3657 19 67.6726 18.9953 68.9982 18.9953C70.3238 18.9953 72.6368 18.9901 74 18.9915C74 17.6185 73.9964 13.4124 73.9964 11.3972V-7.97215e-07" fill="black"/> </g> <defs> <clipPath id="clip0_3958_256____dp"> <rect width="88" height="88" fill="white"/> </clipPath> </defs> </svg></div>            
          </div>
        `;
      }

      cacheDOM() {
        this.input = this.shadowRoot.getElementById('dobInput');
      }

      initMasking() {
        this.input.addEventListener('input', (e) => {
          let value = e.target.value.replace(/\D/g, '');
          let formattedValue = '';
          if (value.length > 0) {
            formattedValue += value.substring(0, 2);
            if (value.length > 2) {
              formattedValue += '/' + value.substring(2, 4);
            }
            if (value.length > 4) {
              formattedValue += '/' + value.substring(4, 8);
            }
          }
          e.target.value = formattedValue;
          this.setAttribute('value', formattedValue);
        });

        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'Backspace') {
            const value = e.target.value;
            if (value.endsWith('/')) {
              e.preventDefault();
              e.target.value = value.substring(0, value.length - 1);
            }
          }
        });
      }

      get value() {
        return this.input ? this.input.value : '';
      }

      set value(val) {
        if (this.input) {
          this.input.value = val;
          this.setAttribute('value', val);
        }
      }

      // isValid() {
      //   const dobRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/;
      //   const val = this.value;
      //   if (!dobRegex.test(val)) {
      //     return { valid: false, message: "Please enter a valid date of birth (dd/mm/yyyy)." };
      //   }
      //   const parts = val.split("/");
      //   const day = parseInt(parts[0], 10);
      //   const month = parseInt(parts[1], 10) - 1;
      //   const year = parseInt(parts[2], 10);
      //   const birthDate = new Date(year, month, day);
      //   if (birthDate.getFullYear() !== year || birthDate.getMonth() !== month || birthDate.getDate() !== day) {
      //     return { valid: false, message: "The date you entered does not exist." };
      //   }
      //   const today = new Date();
      //   const cutoffDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      //   if (birthDate > cutoffDate) {
      //     return { valid: false, message: "You must be at least 18 years old to proceed." };
      //   }
      //   if (year < today.getFullYear() - 120) {
      //     return { valid: false, message: "Please enter a valid birth year." };
      //   }
      //   return { valid: true };
      // }
              isValid() {
    const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/;

    const val = this.value;

    if (!dobRegex.test(val)) {
        return {
            valid: false,
            message: "Please enter a valid date of birth (mm/dd/yyyy)."
        };
    }

    const [monthStr, dayStr, yearStr] = val.split('/');

    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);

    const birthDate = new Date(year, month - 1, day);

    if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month - 1 ||
        birthDate.getDate() !== day
    ) {
        return {
            valid: false,
            message: "The date you entered does not exist."
        };
    }

    const today = new Date();
    const cutoffDate = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate()
    );

    if (birthDate > cutoffDate) {
        return {
            valid: false,
            message: "You must be at least 18 years old to proceed."
        };
    }

    if (year < today.getFullYear() - 120) {
        return {
            valid: false,
            message: "Please enter a valid birth year."
        };
    }

    return { valid: true };
}
    }
    customElements.define('custom-dob-picker', CustomDobPicker);
    
    class WeightTransitionGraph extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
      }

      connectedCallback() {
        this.render();
        this.animateGraph();
      }

      animateGraph() {
        const card = this.shadowRoot.querySelector('.graph-card');
        card.classList.remove('animate');
        void card.offsetWidth;
        card.classList.add('animate');
      }

      render() {
        this.shadowRoot.innerHTML = `
          <style>
            :host { display: block; width: 100%; max-width: 500px; }
            .graph-card { margin-top: 18px; background: #FBFAFC; border: 1px solid #efedf2; border-radius: 20px; padding: 20px 18px 14px; opacity: 0; }
            .graph-card.animate { animation: fadeInUp .8s cubic-bezier(.22, 1, .36, 1) forwards; }
            .graph-title { font-size: 20px; font-weight: 800; color: #1a1a1a; letter-spacing: -.5px; line-height: 1.3; text-align: left; margin-bottom: 6px; font-family: 'Inter', sans-serif; }
            .graph-wrap { position: relative; width: 100%; }
            svg { width: 100%; overflow: visible; }
            .grid-line { stroke: rgba(26, 26, 46, 0.06); stroke-width: 1; stroke-dasharray: 4 4; }
            .axis-base { stroke: rgba(26, 26, 46, 0.12); stroke-width: 1.5; }
            .axis-label { font-size: 14px; fill: #6b7280; font-weight: 700; font-family: 'Inter', sans-serif; }
            .weight-path { fill: none; stroke: url(#weightStroke); stroke-width: 3.5; stroke-linecap: round; }
            .muscle-path { fill: none; stroke: url(#muscleStroke); stroke-width: 3.5; stroke-linecap: round; }
            .leader { fill: none; stroke: #9a9aa4; stroke-width: 1.5; stroke-dasharray: 3 3; opacity: 0; }
            .line-lab { font-size: 12px; font-weight: 700; fill: #1a7d36; font-family: 'Inter', sans-serif; opacity: 0; }
            .stage-dot, .trophy-badge { transform-box: fill-box; transform-origin: center; transform: scale(0); }
            .animate #sweep rect { animation: revealClip 2.4s cubic-bezier(0.5, 0, 0.2, 1) 0.5s forwards; }
            .animate .stage-dot { animation: popIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
            .animate .stage-dot-1 { animation-delay: 0.5s; }
            .animate .stage-dot-2 { animation-delay: 2.7s; }
            .animate .trophy-badge { animation: popIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; animation-delay: 2.7s; }
            .animate .leader, .animate .line-lab { animation: fadeIn 0.4s ease-out forwards; animation-delay: 2.8s; }
            @keyframes revealClip {
              from { width: 0; }
              to { width: 410px; }
            }
            @keyframes popIn {
              to { transform: scale(1); }
            }
            @keyframes fadeIn {
              to { opacity: 1; }
            }
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(15px); }
              to { opacity: 1; transform: translateY(0); }
            }
          </style>

          <div class="graph-card">
            <div class="graph-title">Your weight transition</div>
            <div class="graph-wrap">
              <svg viewBox="-10 -16 410 250" preserveAspectRatio="xMinYMin meet">
                <defs>
                  <linearGradient id="muscleStroke" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stop-color="#178a37"></stop>
                    <stop offset="100%" stop-color="#1a7d36"></stop>
                  </linearGradient>
                  <linearGradient id="weightStroke" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stop-color="#1a1a2e"></stop>
                    <stop offset="60%" stop-color="#5a4a3a"></stop>
                    <stop offset="100%" stop-color="#C8884F"></stop>
                  </linearGradient>
                  <linearGradient id="muscleFill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stop-color="#1a7d36" stop-opacity="0.28"></stop>
                    <stop offset="100%" stop-color="#1a7d36" stop-opacity="0.07"></stop>
                  </linearGradient>
                  <linearGradient id="weightFill" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stop-color="#c9c6d0" stop-opacity="0.20"></stop>
                    <stop offset="100%" stop-color="#C8884F" stop-opacity="0.20"></stop>
                  </linearGradient>
                  <clipPath id="sweep">
                    <rect x="-10" y="-20" height="260" width="0" />
                  </clipPath>
                  <filter id="soft" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="5"></feGaussianBlur></filter>
                  <filter id="soft2" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="3"></feGaussianBlur></filter>
                </defs>
                <line class="grid-line" x1="0" y1="55" x2="385" y2="55"></line>
                <line class="grid-line" x1="0" y1="120" x2="385" y2="120"></line>
                <line class="grid-line" x1="128" y1="20" x2="128" y2="185"></line>
                <line class="grid-line" x1="256" y1="20" x2="256" y2="185"></line>
                <line class="axis-base" x1="0" y1="185" x2="385" y2="185"></line>
                <g clip-path="url(#sweep)">
                  <path d="M 0,55 C 60,57 95,60 128,68 C 175,80 205,118 256,135 C 310,153 350,160 385,162 L 385,185 L 0,185 Z" fill="url(#weightFill)"></path>
                  <path d="M 170,87 C 200,98 224,106 256,111 C 310,122 350,126 385,126 L 385,162 C 350,160 310,153 256,135 C 224,127 200,108 170,87 Z" fill="url(#muscleFill)"></path>
                  <path class="muscle-path" d="M 170,87 C 200,98 224,106 256,111 C 310,122 350,126 385,126"></path>
                  <path class="weight-path" d="M 0,55 C 60,57 95,60 128,68 C 175,80 205,118 256,135 C 310,153 350,160 385,162"></path>
                </g>
                <text class="line-lab" x="385" y="60" text-anchor="end">Muscle retained</text>
                <path class="leader" d="M 385,162 L 385,70"></path>
                <circle class="stage-dot stage-dot-1" cx="0" cy="55" r="6" fill="#fff" stroke="#1a1a2e" stroke-width="3"></circle>
                <circle class="stage-dot stage-dot-2" cx="385" cy="162" r="5" fill="#9a9aa4" stroke="#fff" stroke-width="2"></circle>
                <g class="trophy-badge">
                  <circle cx="385" cy="126" r="14" fill="#1a7d36" style="filter: drop-shadow(0px 3px 6px rgba(26,125,54,0.4));"></circle>
                  <path d="M 385,118 l 2.12,4.55 4.88,0.62 -3.62,3.4 0.95,4.93 -4.33,-2.42 -4.33,2.42 0.95,-4.93 -3.62,-3.4 4.88,-0.62 z" fill="#fff"></path>
                </g>
                <text class="axis-label" x="0" y="212" text-anchor="start">Start</text>
                <text class="axis-label" x="192" y="212" text-anchor="middle">Mo 3</text>
                <text class="axis-label" x="385" y="212" text-anchor="end">Mo 6</text>
              </svg>
            </div>
          </div>
        `;
      }
    }
    customElements.define('weight-transition-graph', WeightTransitionGraph);

    class GlpSvgCanvas extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.progress = 0;
            this.animId = null;
        }

        connectedCallback() {
            this.shadowRoot.innerHTML = `
                <style>
                    :host { display: block; width: 100%; }
                    .container { width: 100%; position: relative; }
                    canvas { display: block; width: 100%; height: auto; }
                </style>
                <div class="container">
                    <canvas id="canvas"></canvas>
                </div>
            `;
            this.canvas = this.shadowRoot.getElementById('canvas');
            this.ctx = this.canvas.getContext('2d');
            
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.setupDimensions();
                    this.triggerAnimation();
                });
            });
        }

        setupDimensions() {
            const dpr = window.devicePixelRatio || 1;
            
            this.baseWidth = 430; 
            this.baseHeight = 310;

            const rect = this.getBoundingClientRect();
            const displayWidth = rect.width > 0 ? rect.width : 430;
            const displayHeight = (this.baseHeight / this.baseWidth) * displayWidth;

            this.canvas.width = displayWidth * dpr;
            this.canvas.height = displayHeight * dpr;
            this.canvas.style.width = '100%';
            this.canvas.style.height = `${displayHeight}px`;
            
            this.ctx.scale(dpr * (displayWidth / this.baseWidth), dpr * (displayHeight / this.baseHeight));

            this.offsetX = 22;
            this.offsetY = 25;

            this.segments = [
                { p0: {x:0, y:40},   cp1: {x:50, y:42},   cp2: {x:90, y:50},   p3: {x:130, y:68},   tEnd: 0.33 },
                { p0: {x:130, y:68}, cp1: {x:170, y:86},  cp2: {x:200, y:104}, p3: {x:240, y:118},  tEnd: 0.66 },
                { p0: {x:240, y:118},cp1: {x:290, y:136}, cp2: {x:340, y:146}, p3: {x:385, y:152},  tEnd: 1.00 }
            ];
        }

        getPointOnSegment(tSeg, seg) {
            const mt = 1 - tSeg;
            const x = Math.pow(mt, 3) * seg.p0.x + 3 * Math.pow(mt, 2) * tSeg * seg.cp1.x + 3 * mt * Math.pow(tSeg, 2) * seg.cp2.x + Math.pow(tSeg, 3) * seg.p3.x;
            const y = Math.pow(mt, 3) * seg.p0.y + 3 * Math.pow(mt, 2) * tSeg * seg.cp1.y + 3 * mt * Math.pow(tSeg, 2) * seg.cp2.y + Math.pow(tSeg, 3) * seg.p3.y;
            return { x: x + this.offsetX, y: y + this.offsetY };
        }

        getGlobalCurvePoint(tGlobal) {
            if (tGlobal <= 0) return { x: this.segments[0].p0.x + this.offsetX, y: this.segments[0].p0.y + this.offsetY };
            if (tGlobal >= 1) return { x: this.segments[2].p3.x + this.offsetX, y: this.segments[2].p3.y + this.offsetY };

            let seg, tSeg;
            if (tGlobal < 0.33) {
                seg = this.segments[0];
                tSeg = tGlobal / 0.33;
            } else if (tGlobal < 0.66) {
                seg = this.segments[1];
                tSeg = (tGlobal - 0.33) / 0.33;
            } else {
                seg = this.segments[2];
                tSeg = (tGlobal - 0.66) / 0.34;
            }
            return this.getPointOnSegment(Math.min(Math.max(tSeg, 0), 1), seg);
        }

        triggerAnimation() {
            cancelAnimationFrame(this.animId);
            this.progress = 0;
            const duration = 1400; 
            let startTime = null;

            const renderLoop = (timestamp) => {
                if (!startTime) startTime = timestamp;
                const elapsed = timestamp - startTime;
                const t = Math.min(elapsed / duration, 1);
                
                this.progress = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
                
                this.drawGraph();

                if (t < 1) {
                    this.animId = requestAnimationFrame(renderLoop);
                }
            };
            this.animId = requestAnimationFrame(renderLoop);
        }

        drawGraph() {
            this.ctx.clearRect(0, 0, this.baseWidth, this.baseHeight);
            const t = this.progress;
            const ox = this.offsetX;
            const oy = this.offsetY;

            const gridY = [30, 70, 110, 150, 190];
            gridY.forEach(y => {
                this.ctx.save();
                this.ctx.beginPath();
                this.ctx.setLineDash([4, 4]);
                this.ctx.strokeStyle = "#edf2f7"; 
                this.ctx.lineWidth = 1;
                this.ctx.moveTo(0 + ox, y + oy);
                this.ctx.lineTo(385 + ox, y + oy);
                this.ctx.stroke();
                this.ctx.restore();
            });

            const labels = [
                { text: 'Start', x: 0 },
                { text: 'Mo 3', x: 96 },
                { text: 'Mo 6', x: 192 },
                { text: 'Mo 9', x: 289 },
                { text: 'Mo 12', x: 385 }
            ];
            
            this.ctx.font = "600 13px 'Inter', sans-serif";
            this.ctx.fillStyle = "#94a3b8";
            this.ctx.textAlign = "center";
            
            labels.forEach(lbl => {
                this.ctx.fillText(lbl.text, lbl.x + ox, 213 + oy);
            });

            this.ctx.font = "800 12px 'Inter', sans-serif";
            this.ctx.fillStyle = "#475569";
            this.ctx.fillText("TIME ON GLP-1", 192 + ox, 244 + oy);

            if (t <= 0) return;

            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.moveTo(0 + ox, 190 + oy);
            this.ctx.lineTo(0 + ox, 40 + oy);

            const resolution = 100;
            const currentLimit = Math.ceil(resolution * t);
            for (let i = 1; i <= currentLimit; i++) {
                const stepT = Math.min(i / resolution, t);
                const pt = this.getGlobalCurvePoint(stepT);
                this.ctx.lineTo(pt.x, pt.y);
            }
            this.ctx.lineTo(this.getGlobalCurvePoint(t).x, 190 + oy);
            this.ctx.closePath();

            const areaGrad = this.ctx.createLinearGradient(0 + ox, 0 + oy, 385 + ox, 190 + oy);
            areaGrad.addColorStop(0, "rgba(76, 185, 99, 0.12)");  
            areaGrad.addColorStop(0.5, "rgba(232, 185, 60, 0.10)"); 
            areaGrad.addColorStop(1, "rgba(217, 72, 72, 0.14)");   
            this.ctx.fillStyle = areaGrad;
            this.ctx.fill();
            this.ctx.restore();

            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.moveTo(0 + ox, 40 + oy);

            for (let i = 1; i <= currentLimit; i++) {
                const stepT = Math.min(i / resolution, t);
                const pt = this.getGlobalCurvePoint(stepT);
                this.ctx.lineTo(pt.x, pt.y);
            }

            const strokeGrad = this.ctx.createLinearGradient(0 + ox, 0 + oy, 385 + ox, 0 + oy);
            strokeGrad.addColorStop(0, "#4CB963");   
            strokeGrad.addColorStop(0.3, "#8ABF4E"); 
            strokeGrad.addColorStop(0.55, "#E8B93C"); 
            strokeGrad.addColorStop(0.78, "#E87A3C"); 
            strokeGrad.addColorStop(1, "#D94848");    

            this.ctx.strokeStyle = strokeGrad;
            this.ctx.lineWidth = 4.5;
            this.ctx.lineCap = "round";
            this.ctx.lineJoin = "round";
            this.ctx.stroke();
            this.ctx.restore();

            const drawStageDot = (x, y, color) => {
                this.ctx.beginPath();
                this.ctx.arc(x + ox, y + oy, 5.5, 0, Math.PI * 2);
                this.ctx.fillStyle = color;
                this.ctx.strokeStyle = "#ffffff";
                this.ctx.lineWidth = 2;
                this.ctx.fill();
                this.ctx.stroke();
            };
            drawStageDot(0, 40, "#4CB963");
            if (t >= 0.33) drawStageDot(130, 68, "#E8B93C");
            if (t >= 0.66) drawStageDot(240, 118, "#E87A3C");
            if (t >= 1.0) drawStageDot(385, 152, "#D94848");
        }
    }
    customElements.define('glp-svg-canvas', GlpSvgCanvas);


    class HumeBarChart extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.progress = 0;
            this.animId = null;
        }

        connectedCallback() {
            this.shadowRoot.innerHTML = `
                <style>
                    :host { display: block; width: 100%; }
                    .canvas-container { width: 100%; position: relative; }
                    canvas { display: block; width: 100%; height: auto; }
                </style>
                <div class="canvas-container">
                    <canvas id="barCanvas"></canvas>
                </div>
            `;
            this.canvas = this.shadowRoot.getElementById('barCanvas');
            this.ctx = this.canvas.getContext('2d');
            
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.initDimensions();
                    this.triggerBarAnimation();
                });
            });
        }

        initDimensions() {
            const dpr = window.devicePixelRatio || 1;
            this.baseW = 410;
            this.baseH = 340;

            const rect = this.getBoundingClientRect();
            const w = rect.width > 0 ? rect.width : 410;
            const h = (this.baseH / this.baseW) * w;

            this.canvas.width = w * dpr;
            this.canvas.height = h * dpr;
            this.canvas.style.width = '100%';
            this.canvas.style.height = `${h}px`;
            
            this.ctx.scale(dpr * (w / this.baseW), dpr * (h / this.baseH));

            this.baselineY = 245; 
            this.barWidth = 115;
            this.radius = 16;

            this.leftBar = {
                targetHeight: 165,
                fillColor: '#e9ebed',
                labelColor: '#939da8',
                value: '44%',
                title: 'Standard GLP-1',
                sub: 'self-managed',
                x: 50
            };

            this.rightBar = {
                targetHeight: 52,
                fillColor: '#2ce274',
                labelColor: '#1a7d36',
                value: '9%',
                title: 'HumeCare+',
                sub: 'guided & compounded',
                x: 245
            };
        }

        drawRoundedBar(x, y, width, height, radius, color) {
            this.ctx.save();
            this.ctx.fillStyle = color;
            this.ctx.beginPath();
            this.ctx.moveTo(x, y + height);
            this.ctx.lineTo(x, y + radius);
            this.ctx.quadraticCurveTo(x, y, x + radius, y);
            this.ctx.lineTo(x + width - radius, y);
            this.ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            this.ctx.lineTo(x + width, y + height);
            this.ctx.closePath();
            this.ctx.fill();
            this.ctx.restore();
        }

        triggerBarAnimation() {
            cancelAnimationFrame(this.animId);
            this.progress = 0;
            const duration = 1200;
            let start = null;

            const animationStep = (timestamp) => {
                if (!start) start = timestamp;
                const elapsed = timestamp - start;
                const t = Math.min(elapsed / duration, 1);
                this.progress = 1 - Math.pow(1 - t, 3);
                this.renderBars();

                if (t < 1) {
                    this.animId = requestAnimationFrame(animationStep);
                }
            };
            this.animId = requestAnimationFrame(animationStep);
        }

        renderBars() {
            this.ctx.clearRect(0, 0, this.baseW, this.baseH);
            const k = this.progress;

            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.strokeStyle = '#e2e8f0';
            this.ctx.lineWidth = 1.2;
            this.ctx.moveTo(50, this.baselineY);
            this.ctx.lineTo(360, this.baselineY);
            this.ctx.stroke();
            this.ctx.restore();

            const currentLeftH = this.leftBar.targetHeight * k;
            const currentLeftY = this.baselineY - currentLeftH;
            this.drawRoundedBar(this.leftBar.x, currentLeftY, this.barWidth, currentLeftH, this.radius, this.leftBar.fillColor);

            const currentRightH = this.rightBar.targetHeight * k;
            const currentRightY = this.baselineY - currentRightH;
            this.drawRoundedBar(this.rightBar.x, currentRightY, this.barWidth, currentRightH, this.radius, this.rightBar.fillColor);

            this.ctx.textAlign = 'center';
            if (k > 0.3) {
                this.ctx.save();
                this.ctx.globalAlpha = Math.min((k - 0.3) / 0.7, 1);
                this.ctx.font = "700 32px 'Inter', sans-serif";
                this.ctx.fillStyle = this.leftBar.labelColor;
                this.ctx.fillText(this.leftBar.value, this.leftBar.x + this.barWidth / 2, this.baselineY - this.leftBar.targetHeight - 15);
                this.ctx.font = "700 32px 'Inter', sans-serif";
                this.ctx.fillStyle = this.rightBar.labelColor;
                this.ctx.fillText(this.rightBar.value, this.rightBar.x + this.barWidth / 2, this.baselineY - this.rightBar.targetHeight - 15);
                this.ctx.restore();
            }

            this.ctx.save();
            this.ctx.globalAlpha = Math.min(k * 1.5, 1);
            this.ctx.font = "700 14px 'Inter', sans-serif";
            this.ctx.fillStyle = '#1e293b';
            this.ctx.fillText(this.leftBar.title, this.leftBar.x + this.barWidth / 2, this.baselineY + 25);
            this.ctx.font = "500 12px 'Inter', sans-serif";
            this.ctx.fillStyle = '#94a3b8';
            this.ctx.fillText(this.leftBar.sub, this.leftBar.x + this.barWidth / 2, this.baselineY + 44);
            this.ctx.font = "700 14px 'Inter', sans-serif";
            this.ctx.fillStyle = '#1e293b';
            this.ctx.fillText(this.rightBar.title, this.rightBar.x + this.barWidth / 2, this.baselineY + 25);
            this.ctx.font = "500 12px 'Inter', sans-serif";
            this.ctx.fillStyle = '#94a3b8';
            this.ctx.fillText(this.rightBar.sub, this.rightBar.x + this.barWidth / 2, this.baselineY + 44);
            this.ctx.font = "500 11.5px 'Inter', sans-serif";
            this.ctx.fillStyle = '#94a3b8';
            this.ctx.fillText("% of members reporting moderate-to-severe nausea", this.baseW / 2, this.baselineY + 75);
            this.ctx.restore();
        }
    }
    customElements.define('hume-bar-chart', HumeBarChart);    
    
    class HumeMuscleChart extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.animProgress = 0;
            this.loopId = null;
        }

        connectedCallback() {
            this.shadowRoot.innerHTML = `
                <style>
                    :host { display: block; width: 100%; }
                    .canvas-box { width: 100%; position: relative; }
                    canvas { display: block; width: 100%; height: auto; }
                </style>
                <div class="canvas-box">
                    <canvas id="humeCanvas"></canvas>
                </div>
            `;
            this.canvas = this.shadowRoot.getElementById('humeCanvas');
            this.ctx = this.canvas.getContext('2d');
            
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.configureScales();
                    this.startHumeAnimation();
                });
            });
        }

        configureScales() {
            const dpr = window.devicePixelRatio || 1;
            this.virtualW = 430;
            this.virtualH = 300;

            const bounds = this.getBoundingClientRect();
            const actualW = bounds.width > 0 ? bounds.width : 500;
            const actualH = (this.virtualH / this.virtualW) * actualW;

            this.canvas.width = actualW * dpr;
            this.canvas.height = actualH * dpr;
            this.canvas.style.width = '100%';
            this.canvas.style.height = `${actualH}px`;
            
            this.ctx.scale(dpr * (actualW / this.virtualW), dpr * (actualH / this.virtualH));

            this.shiftX = 22;
            this.shiftY = 25;

            this.declineSegments = [
                { p0: {x:0, y:40},   cp1: {x:50, y:42},   cp2: {x:90, y:50},   p3: {x:130, y:68} },
                { p0: {x:130, y:68}, cp1: {x:170, y:86},  cp2: {x:200, y:104}, p3: {x:240, y:118} },
                { p0: {x:240, y:118},cp1: {x:290, y:136}, cp2: {x:340, y:146}, p3: {x:385, y:152} }
            ];

            this.humeSegments = [
                { p0: {x:0, y:40},   cp1: {x:100, y:40},  cp2: {x:250, y:44},  p3: {x:385, y:52} }
            ];
        }

        calcBezierPoint(t, curves) {
            let targetCurve, localT;
            if (curves.length === 1) {
                targetCurve = curves[0];
                localT = t;
            } else {
                if (t < 0.33) {
                    targetCurve = curves[0];
                    localT = t / 0.33;
                } else if (t < 0.66) {
                    targetCurve = curves[1];
                    localT = (t - 0.33) / 0.33;
                } else {
                    targetCurve = curves[2];
                    localT = (t - 0.66) / 0.34;
                }
            }
            localT = Math.min(Math.max(localT, 0), 1);
            
            const mt = 1 - localT;
            const x = Math.pow(mt, 3) * targetCurve.p0.x + 3 * Math.pow(mt, 2) * localT * targetCurve.cp1.x + 3 * mt * Math.pow(localT, 2) * targetCurve.cp2.x + Math.pow(localT, 3) * targetCurve.p3.x;
            const y = Math.pow(mt, 3) * targetCurve.p0.y + 3 * Math.pow(mt, 2) * localT * targetCurve.cp1.y + 3 * mt * Math.pow(localT, 2) * targetCurve.cp2.y + Math.pow(localT, 3) * targetCurve.p3.y;
            return { x: x + this.shiftX, y: y + this.shiftY };
        }

        startHumeAnimation() {
            cancelAnimationFrame(this.loopId);
            this.animProgress = 0;
            const runtime = 1400;
            let frameStart = null;

            const frameRunner = (timestamp) => {
                if (!frameStart) frameStart = timestamp;
                const elapsed = timestamp - frameStart;
                const normalizedTime = Math.min(elapsed / runtime, 1);
                
                this.animProgress = 1 - Math.pow(1 - normalizedTime, 3);
                
                this.renderFrame();

                if (normalizedTime < 1) {
                    this.loopId = requestAnimationFrame(frameRunner);
                }
            };
            this.loopId = requestAnimationFrame(frameRunner);
        }

        renderFrame() {
            this.ctx.clearRect(0, 0, this.virtualW, this.virtualH);
            const k = this.animProgress;
            const sx = this.shiftX;
            const sy = this.shiftY;

            const horizontalGrids = [30, 70, 110, 150, 190];
            horizontalGrids.forEach(y => {
                this.ctx.save();
                this.ctx.beginPath();
                this.ctx.setLineDash([4, 4]);
                this.ctx.strokeStyle = "#edf2f7"; 
                this.ctx.lineWidth = 1.2;
                this.ctx.moveTo(0 + sx, y + sy);
                this.ctx.lineTo(385 + sx, y + sy);
                this.ctx.stroke();
                this.ctx.restore();
            });

            const timelineLabels = [
                { txt: 'Start', x: 0 }, { txt: 'Mo 3', x: 96 }, { txt: 'Mo 6', x: 192 },
                { txt: 'Mo 9', x: 289 }, { txt: 'Mo 12', x: 385 }
            ];
            this.ctx.font = "600 13px 'Inter', sans-serif";
            this.ctx.fillStyle = "#94a3b8";
            this.ctx.textAlign = "center";
            timelineLabels.forEach(label => {
                this.ctx.fillText(label.txt, label.x + sx, 213 + sy);
            });

            this.ctx.font = "800 12px 'Inter', sans-serif";
            this.ctx.fillStyle = "#475569";
            this.ctx.fillText("TIME ON GLP-1", 192 + sx, 244 + sy);

            if (k <= 0) return;

            const pointsCount = 100;
            const dynamicLimit = Math.ceil(pointsCount * k);

            this.ctx.save();
            this.ctx.beginPath();
            
            this.ctx.moveTo(0 + sx, 40 + sy);
            
            for (let i = 1; i <= dynamicLimit; i++) {
                const ratio = Math.min(i / pointsCount, k);
                const pt = this.calcBezierPoint(ratio, this.humeSegments);
                this.ctx.lineTo(pt.x, pt.y);
            }
            
            const currentRightLowerPt = this.calcBezierPoint(k, this.declineSegments);
            this.ctx.lineTo(currentRightLowerPt.x, currentRightLowerPt.y);
            
            for (let i = dynamicLimit; i >= 0; i--) {
                const ratio = Math.min(i / pointsCount, k);
                const pt = this.calcBezierPoint(ratio, this.declineSegments);
                this.ctx.lineTo(pt.x, pt.y);
            }
            
            this.ctx.closePath();

            const areaGradient = this.ctx.createLinearGradient(0 + sx, 40 + sy, 0 + sx, 190 + sy);
            areaGradient.addColorStop(0, "rgba(26, 125, 54, 0.18)");
            areaGradient.addColorStop(1, "rgba(26, 125, 54, 0.04)");
            this.ctx.fillStyle = areaGradient;
            this.ctx.fill();
            this.ctx.restore();

            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.moveTo(0 + sx, 40 + sy);
            for (let i = 1; i <= dynamicLimit; i++) {
                const ratio = Math.min(i / pointsCount, k);
                const pt = this.calcBezierPoint(ratio, this.declineSegments);
                this.ctx.lineTo(pt.x, pt.y);
            }
            this.ctx.strokeStyle = "#c4bccf";
            this.ctx.lineWidth = 2.5;
            this.ctx.stroke();
            this.ctx.restore();

            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.moveTo(0 + sx, 40 + sy);
            for (let i = 1; i <= dynamicLimit; i++) {
                const ratio = Math.min(i / pointsCount, k);
                const pt = this.calcBezierPoint(ratio, this.humeSegments);
                this.ctx.lineTo(pt.x, pt.y);
            }
            this.ctx.strokeStyle = "#1a7d36";
            this.ctx.lineWidth = 4;
            this.ctx.stroke();
            this.ctx.restore();

            if (k >= 0.7) {
                this.ctx.save();
                this.ctx.font = "italic 600 13px 'Inter', sans-serif";
                this.ctx.fillStyle = "#1a7d36";
                this.ctx.textAlign = "center";
                this.ctx.globalAlpha = Math.min((k - 0.7) / 0.3, 1);
                this.ctx.fillText("Muscle you keep", 300 + sx, 100 + sy);
                this.ctx.restore();
            }

            if (k >= 0.95) {
                this.ctx.save();
                this.ctx.font = "600 12px 'Inter', sans-serif";
                this.ctx.textAlign = "end";
                this.ctx.globalAlpha = Math.min((k - 0.95) / 0.05, 1);
                
                this.ctx.fillStyle = "#1a7d36";
                this.ctx.fillText("with Hume", 380 + sx, 40 + sy);
                
                this.ctx.fillStyle = "#9b93a8";
                this.ctx.fillText("GLP-1 alone", 380 + sx, 168 + sy);
                this.ctx.restore();
            }

            const drawTargetNode = (x, y, color) => {
                this.ctx.beginPath();
                this.ctx.arc(x + sx, y + sy, 5.5, 0, Math.PI * 2);
                this.ctx.fillStyle = color;
                this.ctx.strokeStyle = "#ffffff";
                this.ctx.lineWidth = 2;
                this.ctx.fill();
                this.ctx.stroke();
            };
            drawTargetNode(0, 40, "#1a7d36");
            if (k >= 1.0) {
                drawTargetNode(385, 52, "#1a7d36");
            }
            if (k >= 1.0) {
                drawTargetNode(385, 152, "#c4bccf");
            }
        }
    }
    customElements.define('hume-muscle-chart', HumeMuscleChart);

    class CustomScratchCard extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.isScraping = false;
            this.isRevealed = false;
            this.lastCoord = null;
            this.confettiParticles = [];
            this.isConfettiActive = false;
            this.dpr = window.devicePixelRatio || 1;
        }

        connectedCallback() {
            this.shadowRoot.innerHTML = `
                <style>
                    :root, * { box-sizing: border-box; margin: 0; padding: 0; }
                    :host { display: block; font-family: 'Inter', sans-serif; color: #1a1a1a; text-align: center; width: 100%; }
                    .heading { font-size: 24px; font-weight: 700; line-height: 1.25; letter-spacing: -0.01em; margin-bottom: 6px; }
                    .caption { font-size: 13px; color: #6b6b6b; margin-bottom: 24px; line-height: 1.5; }
                    .stage { position: relative; width: 100%; }
                    .card-box { position: relative; width: 100%; aspect-ratio: 16 / 10; border-radius: 18px; overflow: hidden; background: #f5f5f5; border: 1px solid #e5e5e5; box-shadow: 0 6px 16px rgba(10, 10, 10, 0.05); user-select: none; -webkit-user-select: none; touch-action: none; }
                    .prize-reveal { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px; background: #f5f5f5; padding: 10px; z-index: 1; }
                    .prize-reveal .banner-text { font-size: 10.5px; font-weight: 800; letter-spacing: 0.22em; text-transform: uppercase; color: #6b4e1a; }
                    .prize-reveal .amount-tag { font-size: 44px; font-weight: 900; letter-spacing: -0.035em; line-height: 1; background: linear-gradient(135deg, #e9c44d 0%, #bd932d 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; }
                    .prize-reveal .terms-text { font-size: 12.5px; color: #6b6b6b; font-weight: 700; letter-spacing: 0.02em; }
                    canvas.foil-layer { position: absolute; inset: 0; width: 100%; height: 100%; display: block; cursor: grab; touch-action: none; z-index: 3; }
                    canvas.foil-layer:active { cursor: grabbing; }
                    .hint-message { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; pointer-events: none; color: #6b4e1a; transition: opacity .35s ease; text-shadow: 0 1px 0 rgba(255,255,255,0.45); z-index: 4; }
                    .hint-text { font-size: 12.5px; font-weight: 800; letter-spacing: 0.22em; text-transform: uppercase; }
                    .card-box.scratched-out .hint-message { opacity: 0; }
                    canvas.confetti-layer { position: absolute; top: -40px; left: -40px; width: calc(100% + 80px); height: calc(100% + 200px); pointer-events: none; z-index: 5; }
                    .status-pill { display: inline-flex; align-items: center; gap: 6px; margin-top: 18px; padding: 9px 14px; font-size: 12.5px; font-weight: 800; color: #1f6131; background: #d4ecd9; border-radius: 999px; letter-spacing: 0.04em; opacity: 0; transform: translateY(8px) scale(0.96); pointer-events: none; }
                    .status-pill.reveal-active { animation: pillIn 0.42s cubic-bezier(0.2, 0.7, 0.2, 1) forwards; }
                    @keyframes pillIn {
                        0%   { opacity: 0; transform: translateY(8px) scale(0.96); }
                        60%  { opacity: 1; transform: translateY(-2px) scale(1.02); }
                        100% { opacity: 1; transform: translateY(0) scale(1); }
                    }
                </style>

                <div class="heading">Congrats! You unlocked a discount</div>
                <p class="caption">Scratch the gold below to reveal your prize.</p>
                
                <div class="stage">
                    <div class="card-box" id="cardContainer">
                        <div class="prize-reveal">
                            <span class="banner-text">You Won Up To</span>
                            <span class="amount-tag">$200</span>
                            <span class="terms-text">off your order</span>
                        </div>
                        <canvas class="foil-layer" id="foilCanvas"></canvas>
                        <div class="hint-message" id="instructionHint">
                            <span class="hint-text">Scratch Here</span>
                        </div>
                    </div>
                    <canvas class="confetti-layer" id="confettiCanvas" aria-hidden="true"></canvas>
                </div>
                
                <div class="status-pill" id="autoApplyPill">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1f6131" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 6L9 17l-5-5"/>
                    </svg>
                    Auto-applied to your order
                </div>
            `;

            this.cardContainer = this.shadowRoot.getElementById('cardContainer');
            this.foilCanvas = this.shadowRoot.getElementById('foilCanvas');
            this.confettiCanvas = this.shadowRoot.getElementById('confettiCanvas');
            this.instructionHint = this.shadowRoot.getElementById('instructionHint');
            this.autoApplyPill = this.shadowRoot.getElementById('autoApplyPill');

            this.fctx = this.foilCanvas.getContext('2d', { willReadFrequently: true });
            this.cctx = this.confettiCanvas.getContext('2d');

            this.initLayers();
            this.attachControlListeners();
        }

        initLayers() {
            this.dpr = window.devicePixelRatio || 1;
            const targetRect = this.cardContainer.getBoundingClientRect();
            const w = targetRect.width > 0 ? targetRect.width : 360;
            const h = targetRect.height > 0 ? targetRect.height : 225;

            this.foilCanvas.width = Math.floor(w * this.dpr);
            this.foilCanvas.height = Math.floor(h * this.dpr);
            this.fctx.setTransform(1, 0, 0, 1, 0, 0);
            this.fctx.scale(this.dpr, this.dpr);

            this.buildGoldTexture(w, h);
            this.resizeConfettiCanvas();
        }

        buildGoldTexture(w, h) {
            const baseGrad = this.fctx.createRadialGradient(w * 0.35, h * 0.3, w * 0.05, w * 0.5, h * 0.5, w * 0.95);
            baseGrad.addColorStop(0, '#fdf0b8');
            baseGrad.addColorStop(0.45, '#e9c44d');
            baseGrad.addColorStop(1, '#bd932d');
            this.fctx.fillStyle = baseGrad;
            this.fctx.fillRect(0, 0, w, h);

            const highlightGrad = this.fctx.createLinearGradient(0, 0, w, h);
            highlightGrad.addColorStop(0, 'rgba(255, 255, 255, 0.22)');
            highlightGrad.addColorStop(0.5, 'rgba(255, 255, 255, 0.00)');
            highlightGrad.addColorStop(1, 'rgba(0, 0, 0, 0.07)');
            this.fctx.fillStyle = highlightGrad;
            this.fctx.fillRect(0, 0, w, h);

            this.fctx.fillStyle = 'rgba(255, 255, 255, 0.12)';
            for (let i = 0; i < 90; i++) {
                this.fctx.beginPath();
                this.fctx.arc(Math.random() * w, Math.random() * h, Math.random() * 1.4, 0, Math.PI * 2);
                this.fctx.fill();
            }
        }

        resizeConfettiCanvas() {
            const containerRect = this.cardContainer.getBoundingClientRect();
            const w = containerRect.width > 0 ? containerRect.width : 360;
            const h = containerRect.height > 0 ? containerRect.height : 225;

            this.confettiCanvas.width = Math.floor((w + 80) * this.dpr);
            this.confettiCanvas.height = Math.floor((h + 200) * this.dpr);
            this.cctx.setTransform(1, 0, 0, 1, 0, 0);
            this.cctx.scale(this.dpr, this.dpr);
        }

        fetchCursorCoordinates(event) {
            const boundaryRect = this.foilCanvas.getBoundingClientRect();
            const interactionSource = event.touches ? event.touches[0] : event;
            return {
                x: interactionSource.clientX - boundaryRect.left,
                y: interactionSource.clientY - boundaryRect.top
            };
        }

        executeScratchNode(x, y) {
            this.fctx.globalCompositeOperation = 'destination-out';
            this.fctx.beginPath();
            this.fctx.arc(x, y, 32, 0, Math.PI * 2);
            this.fctx.fill();
        }

        executeScratchVector(pt1, pt2) {
            this.fctx.globalCompositeOperation = 'destination-out';
            this.fctx.lineWidth = 64;
            this.fctx.lineCap = 'round';
            this.fctx.beginPath();
            this.fctx.moveTo(pt1.x, pt1.y);
            this.fctx.lineTo(pt2.x, pt2.y);
            this.fctx.stroke();
        }

        evaluateSurfaceAreaProgress() {
            const w = this.foilCanvas.width;
            const h = this.foilCanvas.height;
            const pixelMap = this.fctx.getImageData(0, 0, w, h).data;
            
            let clearedNodes = 0;
            let computedTotal = 0;

            for (let idx = 3; idx < pixelMap.length; idx += 4 * 32) {
                computedTotal++;
                if (pixelMap[idx] < 50) clearedNodes++;
            }

            if ((clearedNodes / computedTotal) > 0.35 && !this.isRevealed) {
                this.triggerGlobalReveal();
            }
        }

        triggerGlobalReveal() {
            this.isRevealed = true;
            this.foilCanvas.style.transition = 'opacity .45s ease';
            this.foilCanvas.style.opacity = '0';
            this.cardContainer.classList.add('scratched-out');
            
            this.launchConfettiEruption();
            setTimeout(() => this.autoApplyPill.classList.add('reveal-active'), 250);
        }

        attachControlListeners() {
            const initiationSequence = (e) => {
                if (this.isRevealed) return;
                this.isScraping = true;
                this.instructionHint.style.opacity = '0';
                
                const coordinates = this.fetchCursorCoordinates(e);
                this.lastCoord = coordinates;
                this.executeScratchNode(coordinates.x, coordinates.y);
            };

            const movementSequence = (e) => {
                if (!this.isScraping || this.isRevealed) return;
                
                const currentCoord = this.fetchCursorCoordinates(e);
                if (this.lastCoord) {
                    this.executeScratchVector(this.lastCoord, currentCoord);
                }
                this.executeScratchNode(currentCoord.x, currentCoord.y);
                this.lastCoord = currentCoord;

                if (Math.random() < 0.2) this.evaluateSurfaceAreaProgress();
            };

            const terminationSequence = () => {
                if (!this.isScraping) return;
                this.isScraping = false;
                this.lastCoord = null;
                this.evaluateSurfaceAreaProgress();
            };

            this.foilCanvas.addEventListener('mousedown', initiationSequence);
            this.foilCanvas.addEventListener('mousemove', movementSequence);
            window.addEventListener('mouseup', terminationSequence);

            this.foilCanvas.addEventListener('touchstart', initiationSequence, { passive: false });
            this.foilCanvas.addEventListener('touchmove', movementSequence, { passive: false });
            this.foilCanvas.addEventListener('touchend', terminationSequence);

            window.addEventListener('resize', () => {
                if (!this.isRevealed) this.initLayers();
                else this.resizeConfettiCanvas();
            });
        }

        launchConfettiEruption() {
            this.resizeConfettiCanvas();
            const boundingBox = this.cardContainer.getBoundingClientRect();
            const canvasW = boundingBox.width + 80;
            const canvasH = boundingBox.height + 200;

            this.confettiParticles = [];
            const particleLimit = 90;
            const sourceX = canvasW / 2;
            const sourceY = canvasH * 0.42;
            const colorPalette = ['#e9c44d', '#bd932d', '#fdf0b8', '#1a1a1a', '#737373', '#1f6131'];

            for (let i = 0; i < particleLimit; i++) {
                const radialAngle = (Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.1;
                const dynamicVelocity = 3 + Math.random() * 6;
                
                this.confettiParticles.push({
                    x: sourceX + (Math.random() - 0.5) * 30,
                    y: sourceY + (Math.random() - 0.5) * 20,
                    vx: Math.cos(radialAngle) * dynamicVelocity * (Math.random() < 0.5 ? -1 : 1),
                    vy: -Math.abs(Math.sin(radialAngle) * dynamicVelocity) - 2,
                    dimension: 4 + Math.random() * 6,
                    hexColor: colorPalette[(Math.random() * colorPalette.length) | 0],
                    rotation: Math.random() * Math.PI * 2,
                    angularSpeed: (Math.random() - 0.5) * 0.3,
                    geometryProfile: Math.random() < 0.5 ? 'rect' : 'circle',
                    currentAge: 0,
                    maxAge: 90 + Math.random() * 40
                });
            }

            if (!this.isConfettiActive) {
                this.isConfettiActive = true;
                requestAnimationFrame(() => this.processConfettiFrames());
            }
        }

        processConfettiFrames() {
            const boundingBox = this.cardContainer.getBoundingClientRect();
            const canvasW = boundingBox.width + 80;
            const canvasH = boundingBox.height + 200;
            
            this.cctx.clearRect(0, 0, canvasW, canvasH);
            let activeCount = 0;

            for (const item of this.confettiParticles) {
                item.currentAge++;
                if (item.currentAge > item.maxAge) continue;
                item.vy += 0.18;
                item.vx *= 0.995;
                item.x += item.vx;
                item.y += item.vy;
                item.rotation += item.angularSpeed;
                const lifetimeRatio = 1 - item.currentAge / item.maxAge;
                this.cctx.save();
                this.cctx.globalAlpha = Math.min(1, lifetimeRatio * 1.6);
                this.cctx.translate(item.x, item.y);
                this.cctx.rotate(item.rotation);
                this.cctx.fillStyle = item.hexColor;

                if (item.geometryProfile === 'rect') {
                    this.cctx.fillRect(-item.dimension / 2, -item.dimension / 3, item.dimension, item.dimension * 0.6);
                } else {
                    this.cctx.beginPath();
                    this.cctx.arc(0, 0, item.dimension * 0.4, 0, Math.PI * 2);
                    this.cctx.fill();
                }
                this.cctx.restore();
                activeCount++;
            }

            if (activeCount > 0) {
                requestAnimationFrame(() => this.processConfettiFrames());
            } else {
                this.isConfettiActive = false;
                this.cctx.clearRect(0, 0, canvasW, canvasH);
            }
        }
    }
    customElements.define('custom-scratch-card', CustomScratchCard);

    class HumeWeightGradientChart extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
            this.currentProgress = 0;
            this.frameRef = null;
        }

        connectedCallback() {
            this.shadowRoot.innerHTML = `
                <style>
                    :host { display: block; width: 100%; }
                    .card-bg { 
                        width: 100%; 
                        background: #ffffff; 
                        border-radius: 24px; 
                        box-shadow: 0 8px 24px rgba(148, 163, 184, 0.06);
                        border: 1px solid #f1f5f9;
                    }
                    canvas { display: block; width: 100%; height: auto; }
                </style>
                <div class="card-bg">
                    <canvas id="weightGradientCanvas"></canvas>
                </div>
            `;
            this.canvas = this.shadowRoot.getElementById('weightGradientCanvas');
            this.ctx = this.canvas.getContext('2d');
            
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.scaleCanvasDimensions();
                    this.triggerVerticalGrowthAnimation();
                });
            });
        }

        scaleCanvasDimensions() {
            const dpr = window.devicePixelRatio || 1;
            this.baseWidth = 380;
            this.baseHeight = 390;

            const boundary = this.getBoundingClientRect();
            const w = boundary.width > 0 ? boundary.width : 380;
            const h = (this.baseHeight / this.baseWidth) * w;

            this.canvas.width = w * dpr;
            this.canvas.height = h * dpr;
            this.canvas.style.width = '100%';
            this.canvas.style.height = `${h}px`;
            
            this.ctx.scale(dpr * (w / this.baseWidth), dpr * (h / this.baseHeight));

            this.baselineY = 250;
            this.barWidth = 111;

            this.leftBarParams = {
                x: 42,
                targetH: 90,
                color: '#e9ebed',
                label: 'On your own'
            };

            this.rightBarParams = {
                x: 212,
                targetH: 189,
                label: 'With HumeCare+'
            };
        }

        drawElegantBarShape(x, y, w, h, radius, context) {
            context.beginPath();
            context.moveTo(x, y + h); 
            context.lineTo(x, y + radius); 
            context.quadraticCurveTo(x, y, x + radius, y); 
            context.lineTo(x + w - radius, y); 
            context.quadraticCurveTo(x + w, y, x + w, y + radius); 
            context.lineTo(x + w, y + h); 
            context.closePath();
            context.fill();
        }

        triggerVerticalGrowthAnimation() {
            cancelAnimationFrame(this.frameRef);
            this.currentProgress = 0;
            const runDuration = 1250;
            let timelineStart = null;

            const executeStep = (timestamp) => {
                if (!timelineStart) timelineStart = timestamp;
                const runtime = timestamp - timelineStart;
                const ratio = Math.min(runtime / runDuration, 1);
                this.currentProgress = 1 - Math.pow(1 - ratio, 3);
                this.renderActiveLayer();
                if (ratio < 1) {
                    this.frameRef = requestAnimationFrame(executeStep);
                }
            };
            this.frameRef = requestAnimationFrame(executeStep);
        }

        renderActiveLayer() {
            this.ctx.clearRect(0, 0, this.baseWidth, this.baseHeight);
            const k = this.currentProgress;

            this.ctx.save();
            this.ctx.font = "700 23px 'Inter', sans-serif";
            this.ctx.fillStyle = '#111827';
            this.ctx.fillText("Weight Lost", 26, 54);
            this.ctx.restore();

            const structuralGrids = [74, 162, 250];
            structuralGrids.forEach(yCoord => {
                this.ctx.save();
                this.ctx.beginPath();
                this.ctx.setLineDash([4, 4]);
                this.ctx.strokeStyle = '#e2e8f0';
                this.ctx.lineWidth = 1.2;
                this.ctx.moveTo(26, yCoord);
                this.ctx.lineTo(354, yCoord);
                this.ctx.stroke();
                this.ctx.restore();
            });

            const dynamicLeftH = this.leftBarParams.targetH * k;
            const dynamicLeftY = this.baselineY - dynamicLeftH;
            this.ctx.save();
            this.ctx.fillStyle = this.leftBarParams.color;
            this.drawElegantBarShape(this.leftBarParams.x, dynamicLeftY, this.barWidth, dynamicLeftH, 18, this.ctx);
            this.ctx.restore();

            const dynamicRightH = this.rightBarParams.targetH * k;
            const dynamicRightY = this.baselineY - dynamicRightH;
            this.ctx.save();
            
            const verticalMeshGrad = this.ctx.createLinearGradient(
                this.rightBarParams.x, 
                dynamicRightY,
                this.rightBarParams.x, 
                this.baselineY 
            );
            
            verticalMeshGrad.addColorStop(0, '#4ADE80');
            verticalMeshGrad.addColorStop(0.5, '#1882FF');
            verticalMeshGrad.addColorStop(1, '#F87171');
            
            this.ctx.fillStyle = verticalMeshGrad;
            this.drawElegantBarShape(this.rightBarParams.x, dynamicRightY, this.barWidth, dynamicRightH, 26, this.ctx);
            this.ctx.restore();

            this.ctx.save();
            this.ctx.font = "700 13px 'Inter', sans-serif";
            this.ctx.fillStyle = '#1e293b';
            this.ctx.textAlign = 'center';
            this.ctx.globalAlpha = Math.min(k * 1.4, 1);
            
            this.ctx.fillText(this.leftBarParams.label, this.leftBarParams.x + this.barWidth / 2, this.baselineY + 24);
            this.ctx.fillText(this.rightBarParams.label, this.rightBarParams.x + this.barWidth / 2, this.baselineY + 24);
            this.ctx.restore();

            if (k >= 0.75) {
                const badgeOpacity = Math.min((k - 0.75) / 0.25, 1);
                this.ctx.save();
                this.ctx.globalAlpha = badgeOpacity;

                this.ctx.font = "800 34px 'Inter', sans-serif";
                this.ctx.fillStyle = '#2ce274';
                this.ctx.fillText("2X", 274, 60);
                this.ctx.font = "26px 'Inter', sans-serif";
                this.ctx.fillText("🎉", 232, 55);
                this.ctx.restore();
            }

            this.ctx.save();
            this.ctx.font = "500 13px 'Inter', sans-serif";
            this.ctx.fillStyle = '#64748b'; 
            this.ctx.globalAlpha = Math.min(k * 1.2, 1);
            const lineQuote1 = "Based on a clinical study over 12 weeks of active";
            const lineQuote2 = "HumeCare+ users.";
            this.ctx.fillText(lineQuote1, 26, 316);
            this.ctx.fillText(lineQuote2, 26, 336);
            this.ctx.restore();
        }
    }
    customElements.define('hume-weight-gradient-chart', HumeWeightGradientChart);

    const viewport = document.getElementById('carouselViewport');
    const track = document.getElementById('carouselTrack');
    const filler = document.getElementById('progressFiller');
    const btnPrev = document.getElementById('btnPrev');
    const btnNext = document.getElementById('btnNext');
    let currentIndex = 0;
    const totalSlides = document.querySelectorAll('.testimonial___slide').length;
    let isDragging = false;
    let startX = 0;

    function updateSlidePosition() {
      if (!track || totalSlides === 0) return;
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      if (filler) {
        const currentProgress = ((currentIndex + 1) / totalSlides) * 100;
        filler.style.width = `${currentProgress}%`;
        filler.style.transform = 'none';
      }
      if (currentIndex < totalSlides - 1) { btnNext.style.opacity = '1'; } else { btnNext.style.opacity = '0.5'; }
      if (currentIndex > 0) { btnPrev.style.opacity = '1'; } else { btnPrev.style.opacity = '0.5'; }      
    }

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        if (currentIndex < totalSlides - 1) {
          currentIndex++;
        }
        updateSlidePosition();
      });
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
        }
        updateSlidePosition();
      });
    }

    if (viewport && track) {
      viewport.addEventListener('pointerdown', (e) => {
        isDragging = true;
        startX = e.clientX;
        viewport.setPointerCapture(e.pointerId);
        track.style.transition = 'none';
        document.body.style.userSelect = 'none';
      });

      viewport.addEventListener('pointermove', (e) => {
        if (!isDragging) return;
        const currentX = e.clientX;
        const diffX = currentX - startX;
        const viewportWidth = viewport.offsetWidth;
        const baseTranslate = -currentIndex * viewportWidth;
        const totalMove = baseTranslate + diffX;
        track.style.transform = `translateX(${totalMove}px)`;
      });

      viewport.addEventListener('pointerup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        viewport.releasePointerCapture(e.pointerId);
        track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
        document.body.style.userSelect = '';
        const endX = e.clientX;
        const diffX = endX - startX;
        const threshold = viewport.offsetWidth * 0.15;
        if (diffX < -threshold && currentIndex < totalSlides - 1) {
          currentIndex++;
        } else if (diffX > threshold && currentIndex > 0) {
          currentIndex--;
        }
        updateSlidePosition();
      });

      viewport.addEventListener('pointercancel', () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
        document.body.style.userSelect = '';
        updateSlidePosition();
      });
    }
    updateSlidePosition();

    function step__pgs_move___animate() {
      const step__pgs_move___b1 = document.getElementById('step__pgs_move___bar1');
      const step__pgs_move___b2 = document.getElementById('step__pgs_move___bar2');
      step__pgs_move___b1.style.transition = 'none';
      step__pgs_move___b2.style.transition = 'none';
      step__pgs_move___b1.style.height = '0px';
      step__pgs_move___b2.style.height = '0px';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        step__pgs_move___b1.style.transition = 'height 1s cubic-bezier(.34,1.0,.64,1)';
        step__pgs_move___b2.style.transition = 'height 1.15s cubic-bezier(.34,1.0,.64,1) 0.1s';
        step__pgs_move___b1.style.height = '105px';
        step__pgs_move___b2.style.height = '210px';
      }));
    }

    const addressInput = document.getElementById('ctrl__autocomplete');
    const suggestionsLog = document.getElementById('address__suggestions');
    const cityInput = document.querySelector('input[name="city_name"]');
    const stateSelect = document.getElementById('address__state');
    const zipInput = document.getElementById('address__zip');
    const errorMsgElement = document.getElementById('state__error__msg');
    const nextButton = document.querySelector('.js-button-move-slide');
    const restrictedStates = ['Alabama', 'Arkansas', 'Louisiana', 'Mississippi'];
    if (!addressInput || !suggestionsLog) return;
    const autocompleteService = new google.maps.places.AutocompleteService();
    const placesService = new google.maps.places.PlacesService(document.createElement('div'));

    function checkStateEligibility(selectedState) {
        if (!errorMsgElement) return true;
        if (restrictedStates.includes(selectedState)) {
            errorMsgElement.textContent = "We're sorry, our services are not eligible in this state.";
            errorMsgElement.classList.remove('hidden');
            errorMsgElement.style.display = 'block';
            return false;
        } else {
            errorMsgElement.textContent = "";
            errorMsgElement.classList.add('hidden');
            errorMsgElement.style.display = 'none';
            return true;
        }
    }

    addressInput.addEventListener('input', () => {
        const query = addressInput.value.trim();
        if (query.length < 3) {
            suggestionsLog.innerHTML = '';
            suggestionsLog.style.display = 'none';
            return;
        }
        autocompleteService.getPlacePredictions({
            input: query,
            componentRestrictions: { country: 'us' },
            types: ['address']
        }, (predictions, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                suggestionsLog.innerHTML = '';
                suggestionsLog.style.display = 'none';
                return;
            }

            suggestionsLog.innerHTML = '';
            suggestionsLog.style.display = 'block';
            predictions.forEach((prediction) => {
                const li = document.createElement('li');
                li.className = 'suggestion__item';
                li.style.cursor = 'pointer';
                li.style.padding = '10px';
                li.textContent = prediction.description;
                li.addEventListener('click', () => {
                    addressInput.value = prediction.structured_formatting.main_text;
                    suggestionsLog.style.display = 'none';
                    fetchPlaceDetails(prediction.place_id);
                });
                suggestionsLog.appendChild(li);
            });
        });
    });

    function fetchPlaceDetails(placeId) {
        placesService.getDetails({
            placeId: placeId,
            fields: ['address_components']
        }, (place, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !place) {
                console.error('Failed to get place details');
                return;
            }

            if (cityInput) cityInput.value = '';
            if (stateSelect) stateSelect.value = '';
            if (zipInput) zipInput.value = '';

            place.address_components.forEach((component) => {
                const types = component.types;
                if (types.includes('locality')) {
                    if (cityInput) cityInput.value = component.long_name;
                } else if (types.includes('sublocality_level_1') && (!cityInput || cityInput.value === '')) {
                    if (cityInput) cityInput.value = component.long_name;
                }
                if (types.includes('administrative_area_level_1')) {
                    if (stateSelect) {
                        const stateName = component.long_name;
                        stateSelect.value = stateName;
                        checkStateEligibility(stateName);
                        const floridaCheckbox = document.getElementById('florida__checkbox');
                        if (floridaCheckbox) {
                            if (stateName === 'Florida') {
                                floridaCheckbox.classList.remove('hidden');
                            } else {
                                floridaCheckbox.classList.add('hidden');
                            }
                        }                        
                    }
                }
                if (types.includes('postal_code')) {
                    if (zipInput) zipInput.value = component.long_name;
                }
            });
        });
    }

    if (stateSelect) {
        stateSelect.addEventListener('change', function() {
            const selectedState = this.value;
            checkStateEligibility(selectedState);
            const floridaCheckbox = document.getElementById('florida__checkbox');
            if (floridaCheckbox) {
                if (selectedState === 'Florida') {
                    floridaCheckbox.classList.remove('hidden');
                } else {
                    floridaCheckbox.classList.add('hidden');
                }
            }
        });
    }

    document.addEventListener('click', (e) => {
        if (e.target !== addressInput && e.target !== suggestionsLog) {
            suggestionsLog.style.display = 'none';
        }
    });

    function validateAddressSlide() {
        const currentAddress = addressInput.value.trim();
        const currentCity = cityInput ? cityInput.value.trim() : "";
        const currentState = stateSelect ? stateSelect.value : "";
        const currentZip = zipInput ? zipInput.value.trim() : "";
        if (currentAddress === "" || currentCity === "" || currentState === "" || currentZip === "") {
            if (errorMsgElement) {
                errorMsgElement.textContent = "Please fill in all required address fields.";
                errorMsgElement.classList.remove('hidden');
                errorMsgElement.style.display = 'block';
            }
            return false;
        }
        return checkStateEligibility(currentState);
    }

    if (nextButton) {
        nextButton.addEventListener('click', (e) => {
            const isEligible = validateAddressSlide();
            if (!isEligible) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    const Qzslides = document.querySelectorAll(`[js-slide-quiz-main]`);
    const progressBarSpan = document.querySelector(".quiz__optimize___header__progress span");
    const backButton = document.querySelector('[js-reverse--back]');
    const quizWrapper = document.querySelector('.quiz__advancement__wp');
    const nextButtons = document.querySelectorAll(`[js-button-move-slide]`);
    let currentSlideIndex = 0;
    const totalQzSlides = 41;

    function syncUserName(inputElement) {
      const rawValue = inputElement.value.trim();
      const nameToDisplay = rawValue !== "" ? rawValue : "there";
      const nameUpdateElements = document.querySelectorAll("[js-first-name-update]");
      nameUpdateElements.forEach((element) => {
        element.textContent = nameToDisplay;
      });
    }

    const nameInput = document.querySelector('input[name="name"], .js-input-name');
    if (nameInput) {
      nameInput.addEventListener("input", function() {
        syncUserName(this);
      });
    }

    function updateProgressBar() {
      if (!progressBarSpan) return;
      const progressPercentage = (currentSlideIndex / (totalQzSlides - 1)) * 100;
      progressBarSpan.style.width = `${progressPercentage}%`;
    }

    function showSlideError(currentSlide, message) {
      let errorDiv = currentSlide.querySelector(".quiz-error-message");
      if (!errorDiv) {
        errorDiv = document.createElement("div");
        errorDiv.className = "quiz-error-message";
        errorDiv.style.color = "#ff3b30";
        errorDiv.style.fontSize = "14px";
        errorDiv.style.fontWeight = "500";
        errorDiv.style.marginTop = "12px";
        errorDiv.style.textAlign = "center";
        currentSlide.appendChild(errorDiv);
      }
      errorDiv.textContent = message;
    }

    function clearSlideError(currentSlide) {
      const errorDiv = currentSlide.querySelector(".quiz-error-message");
      if (errorDiv) {
        errorDiv.textContent = "";
      }
    } 
    
    function updateBackButtonVisibility() {
        if (!backButton) return;
        if (currentSlideIndex <= 0) {
            backButton.classList.add('hidden');
        } else {
            backButton.classList.remove('hidden');
        }
    }    

    function initSlides() {
      if (Qzslides.length === 0) return;
      
      Qzslides.forEach((slide, index) => {
        if (index === 0) {
          slide.classList.remove("hidden");
        } else {
          slide.classList.add("hidden");
        }
      });
      currentSlideIndex = 0;
      updateProgressBar();
      updateBackButtonVisibility();
    }

    function convertLbsToKg(lbs) {
        if (isNaN(lbs) || lbs === null || lbs === '') return 0;
        const kg = parseFloat(lbs) * 0.45359237;
        return parseFloat(kg.toFixed(1)); 
    }

    function getFutureDateString(monthsToAdd) {
        const today = new Date();
        today.setMonth(today.getMonth() + parseInt(monthsToAdd, 10));
        const day = today.getDate();
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
            "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
        ];
        const monthStr = monthNames[today.getMonth()];
        return `${monthStr} ${day}`;
    }

    function formatDate(value) {
        if (!value) return '';
        const trimmedValue = String(value).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) return trimmedValue;
        const mdYMatch = trimmedValue.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
        if (mdYMatch) {
            const mm = mdYMatch[1].padStart(2, '0');
            const dd = mdYMatch[2].padStart(2, '0');
            const yyyy = mdYMatch[3];
            return `${yyyy}-${dd}-${mm}`;
        }
        const date = new Date(trimmedValue);
        if (!isNaN(date.getTime())) {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${dd}-${mm}`;
        }
        return '';
    }

    function convertCmToInches(cm, precision = 'decimal') {
      if (typeof cm !== 'number' || isNaN(cm)) {
        throw new Error('Please provide a valid number for centimeters.');
      }
      const inches = cm / 2.54;
      switch (precision) {
        case 'round':
          return Math.round(inches);
        case 'fixed':
          return inches.toFixed(2);
        case 'decimal':
        default:
          return inches;
      }
    }    

    function goToNextSlide() {
      if (Qzslides.length === 0) return;
      const currentSlide = Qzslides[currentSlideIndex];
      clearSlideError(currentSlide);

      const checkboxes = currentSlide.querySelectorAll('input[type="checkbox"]:not(#accept__right_reserved), input[type="radio"]');
      if (checkboxes.length > 0) {
        const isAnyChecked = Array.from(checkboxes).some(cb => cb.checked);
        if (!isAnyChecked) {
          showSlideError(currentSlide, "Please select at least one option to proceed.");
          return;
        }
      }

      const dobComponents = currentSlide.querySelectorAll('#userDob');
      if (dobComponents.length > 0) {
        for (let el of dobComponents) {
          const value = el.value.trim();
          if (value === "") {
            showSlideError(currentSlide, "Please enter your date of birth.");
            if (el.shadowRoot && el.shadowRoot.getElementById('dobInput')) {
              el.shadowRoot.getElementById('dobInput').focus();
            }
            return;
          } 
          const validationResult = el.isValid();
          if (!validationResult.valid) {
            showSlideError(currentSlide, validationResult.message);
            if (el.shadowRoot && el.shadowRoot.getElementById('dobInput')) {
              el.shadowRoot.getElementById('dobInput').focus();
            }
            return;
          }
        }
      }    

      const inputs = currentSlide.querySelectorAll('input[type="text"]:not(#userDob):not([name="address2"]), input[type="email"]');
      for (let input of inputs) {
        const value = input.value.trim();

        if (value === "") {
          showSlideError(currentSlide, "This field cannot be left empty.");
          input.focus();
          return;
        }

        if (input.type === "text" && (input.name === "name" || input.classList.contains("js-input-name"))) {
          const nameRegex = /^[a-zA-Z\s]+$/;
          if (value.trim().length < 1) {
            showSlideError(currentSlide, "First name must be at least 3 characters long.");
            input.focus();
            return;
          }
          if (!nameRegex.test(value)) {
            showSlideError(currentSlide, "Please enter a valid name (letters only, no numbers or special characters).");
            input.focus();
            return;
          }
          syncUserName(input);
        }else if (input.type === "text" && (input.name === "last-name" || input.classList.contains("js-input-last-name"))) {
          const nameRegex = /^[a-zA-Z\s]+$/;
          if (value.trim().length < 1) {
            showSlideError(currentSlide, "Last name must be at least 3 characters long.");
            input.focus();
            return;
          }
          if (!nameRegex.test(value)) {
            showSlideError(currentSlide, "Please enter a valid last name (letters only, no numbers or special characters).");
            input.focus();
            return;
          }
        }

        if (input.type === "email" || input.name === "email" || input.classList.contains("js-input-email")) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            showSlideError(currentSlide, "Please enter a valid email address (e.g., name@domain.com).");
            input.focus();
            return;
          }
        }
      }

      if( currentSlide.classList.contains('step_____thirty__one') ){
        const stateSelect = document.getElementById('address__state');
        const floridaCheckbox = document.getElementById('accept__right_reserved');
        if (stateSelect && (stateSelect.value === 'Florida' || stateSelect.value === 'FL')) {
          if (floridaCheckbox && !floridaCheckbox.checked) {
            showSlideError(currentSlide, "Please accept the Florida terms to proceed.");
            return;
          }
        }      
      }      

      // if (currentSlide.classList.contains(`step_____eleven`)) {
      //   setTimeout(() => {
      //     step__pgs_move___animate();
      //   }, 400);        
      // }

      if (currentSlide.classList.contains(`step_____thirty`)) {
        const circleProgress = document.querySelector('custom-circle-progress');
        if (circleProgress && typeof circleProgress.resetAndAnimate === 'function') {
          circleProgress.resetAndAnimate();
        }
      }      

      if (currentSlideIndex < Qzslides.length - 1) {
        Qzslides[currentSlideIndex].classList.add("hidden");

        let stepIncrement = 1;

        if (currentSlide.classList.contains(`step_____thirteen`)) {
          const selectedOption = currentSlide.querySelector(`[name="have__tried_before"]:checked`);
          if (selectedOption && selectedOption.value === 'Yes') {
            stepIncrement = 2;
          }
        }

        if (currentSlide.classList.contains(`step_____fifteen`)) {
          const selectedOption = document.querySelector(`[name="have__tried_before"]:checked`);
          if (selectedOption && selectedOption.value === 'Not yet') {
            stepIncrement = 2;
          }
        }        

        if (currentSlideIndex + stepIncrement < Qzslides.length) {
          currentSlideIndex += stepIncrement;
        } else {
          currentSlideIndex = Qzslides.length - 1;
        }

        Qzslides[currentSlideIndex].classList.remove("hidden");
        
        updateProgressBar();
        updateBackButtonVisibility();

        try {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          if (window.scrollY === 0) {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          }
        } catch (error) {
          window.scrollTo(0, 0);
        }
      } else {
        console.log("Quiz Finished!");
      }

      let weightWantToLoose = document?.querySelector(`weight-picker`)?.value;
      let currentWeightHave = document?.querySelector(`weight-unit-picker`)?.value;
      currentWeightHave = currentWeightHave.lbs;
      let RemainingWeight = parseInt(currentWeightHave) - parseInt(weightWantToLoose);
      let TimeIntervalPeriod = document?.querySelector('input[name="real_results"]:checked');
      if (TimeIntervalPeriod) {
        let TimeIntervalPeriodTill = TimeIntervalPeriod.value;
        document.querySelectorAll(`[js-weight-want]`).forEach((el)=>{ el.innerHTML = `${RemainingWeight}lbs` });
        document.querySelectorAll(`[js-want-to-loose-weight]`).forEach((el)=>{ el.innerHTML = `${weightWantToLoose}lbs` });
        document.querySelectorAll(`[js-within---months]`).forEach((el)=>{ el.innerHTML = `${TimeIntervalPeriodTill}` });
        document.querySelectorAll(`[js-weight-want-times], [js-want-to-loose-weight-time]`).forEach((el)=>{ el.innerHTML = `${getFutureDateString(TimeIntervalPeriodTill)}` });
      } 

      if (currentSlide.classList.contains(`step_____sixteen`)) {
        document.querySelector('weight-transition-graph').animateGraph();
      } 
      
      if (currentSlide.classList.contains(`step_____fouteen`) || currentSlide.classList.contains(`step_____fifteen`)) {
        document.querySelector('glp-svg-canvas').triggerAnimation();
      }       
      
      if (currentSlide.classList.contains(`step_____nineteen`)) {
        document.querySelector('hume-muscle-chart').startHumeAnimation();
      }

      // if (currentSlide.classList.contains(`step_____twenty__one`)) {
      //   document.querySelector('hume-bar-chart').triggerBarAnimation();
      // }    

      let existingData = {};
      try {
          existingData = JSON.parse(localStorage.getItem('patient_starter')) || {};
      } catch(e) {
          existingData = {};
      }   

      const nameInput = document.querySelector(`.js-input-name`);
      if (nameInput) patientData.firstName = String(nameInput.value.trim());
      
      const LastNameInput = document.querySelector(`.js-input-last-name`);
      if (LastNameInput) patientData.lastName = String(LastNameInput.value.trim());      
      
      const emailInput = document.querySelector(`input[name="accepts____email"]`);
      if (emailInput) patientData.email = String(emailInput.value.trim());
      
      const dobPicker = document.querySelector(`custom-dob-picker`);
      if (dobPicker && dobPicker.value) patientData.dateOfBirth = formatDate(dobPicker.value);
      
      const genderInput = document.querySelector(`input[name="gender"]:checked`);
      if (genderInput) {
        patientData.gender = Number(genderInput.value);
      }

      const weightPicker = document.querySelector(`weight-unit-picker`);
      if (weightPicker && weightPicker.value) patientData.weight = Number(weightPicker.value.lbs);
      
      const heightPicker = document.querySelector(`height-picker`);
      if (heightPicker && heightPicker.value) patientData.height = convertCmToInches(Number(heightPicker.value.cm), 'round');
      
      
      const strVal = document.querySelector(`input[name="str_val"]`);
      if (strVal) patientData.address.address = String(strVal.value.trim());
      
      const addr2 = document.querySelector(`input[name="address2"]`);
      if (addr2) patientData.address.address2 = String(addr2.value.trim());
      
      const zipCode = document.querySelector(`input[name="zip_code"]`);
      if (zipCode) patientData.address.zipCode = String(zipCode.value.trim());
      
      const cityName = document.querySelector(`input[name="city_name"]`);
      if (cityName) patientData.address.cityName = String(cityName.value.trim());
      
      const stateName = document.querySelector(`select[name="state_name"]`);
      if (stateName) patientData.address.stateName = String(stateName.value.trim());
      
      const wPicker = document.querySelector(`weight-picker`);
      if (wPicker && wPicker.value) patientData.weightLossGoal = String(wPicker.value) + 'lbs';

      const ordered = {
          first_name    : patientData.firstName    ?? null,
          last_name     : patientData.lastName     ?? null,
          email         : patientData.email         ?? null,
          date_of_birth : patientData.dateOfBirth ?? null,
          gender        : patientData.gender        ?? null,
          weight        : patientData.weight       ?? null,
          height        : patientData.height        ?? null,
          address: {
              address      : patientData.address?.address      ?? null,
              address2     : patientData.address?.address2     ?? null,
              zip_code     : patientData.address?.zipCode     ?? null,
              city_name    : patientData.address?.cityName    ?? null,
              state_name   : patientData.address?.stateName   ?? null,
          },
          weightLossGoal: (() => {
                const rawValue = patientData.weightLossGoal || '';
                const weight = parseInt(rawValue, 10);

                if (isNaN(weight) || weight <= 0) {
                    return '';
                } else if (weight >= 1 && weight <= 15) {
                    return '1-15lbs';
                } else if (weight >= 16 && weight <= 50) {
                    return '16-50lbs';
                } else {
                    return '51+lbs';
                }
          })(),
      };
      
      localStorage.setItem('patient_starter', JSON.stringify(ordered));

      // console.log(JSON.stringify(ordered));

      const stepName = currentSlide?.dataset.step || `step_${currentSlideIndex}`;
      fireStepPixel(stepName);
    }

    if (backButton) {
      backButton.addEventListener('click', () => {
        if (currentSlideIndex > 0) {
          clearSlideError(Qzslides[currentSlideIndex]);
          Qzslides[currentSlideIndex].classList.add('hidden');
          let stepDecrement = 1;
          const potentialStep13Index = currentSlideIndex - 2;
          if (potentialStep13Index >= 0) {
            const checkSlide = Qzslides[potentialStep13Index];
            
            if (checkSlide && checkSlide.classList.contains('step_____thirteen')) {
              const selectedOption = checkSlide.querySelector(`[name="have__tried_before"]:checked`);
              if (selectedOption && selectedOption.value === 'Yes') {
                stepDecrement = 2;
              }
            }
            if (checkSlide && checkSlide.classList.contains('step_____fifteen')) {
              const selectedOption = document.querySelector(`[name="have__tried_before"]:checked`);
              if (selectedOption && selectedOption.value === 'Not yet') {
                stepDecrement = 2;
              }
            }            
          }

          const currentSlide = Qzslides[currentSlideIndex];
          if (currentSlide) {
            const circleProgress = currentSlide.querySelector('custom-circle-progress');
            if (circleProgress && typeof circleProgress.stopAndReset === 'function') {
              circleProgress.stopAndReset();
            }
          }

          currentSlideIndex = Math.max(0, currentSlideIndex - stepDecrement);
          const previousSlide = Qzslides[currentSlideIndex];
          if (previousSlide) {
            previousSlide.classList.remove('hidden');
            const prevCircle = previousSlide.querySelector('custom-circle-progress');
            if (prevCircle && typeof prevCircle.stopAndReset === 'function') {
              prevCircle.stopAndReset();
            }
            if (previousSlide.classList.contains('step_____thirty__two')) {
              setTimeout(() => {
                if (typeof setProgressBar === 'function') {
                  setProgressBar(100, 100);
                }
              }, 400);        
            }
          } else {
            currentSlideIndex = 0;
            Qzslides[0].classList.remove('hidden');
          }
      
          updateProgressBar();
          updateBackButtonVisibility();

          try {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            if (window.scrollY === 0) {
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
            }
          } catch (error) {
            window.scrollTo(0, 0);
          }
        }
      });
    }

    nextButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        goToNextSlide();
      });
    });

    initSlides();
    

    document.querySelector(`[js-lets-submit--form]`).addEventListener('click', async (e) => {
        e.preventDefault(); 
        const initialStep = document.querySelector('[js-slide-quiz-main]:not(.hidden)');
        fireStepPixel(initialStep?.dataset.step || 'step_32');      
        const updatedPatientData = {
            firstName: String(document.querySelector(`.js-input-name`)?.value?.trim() || ''),
            lastName: String(document.querySelector(`.js-input-last-name`)?.value?.trim() || ''),
            email: String(document.querySelector(`input[name="accepts____email"]`)?.value?.trim() || ''),
            dateOfBirth: formatDate(document.querySelector(`custom-dob-picker`)?.value),
            gender: Number(document.querySelector(`input[name="gender"]:checked`).value),
            weight: Number(document.querySelector(`weight-unit-picker`)?.value?.lbs || 0),
            height: convertCmToInches(Number(document.querySelector(`height-picker`)?.value?.cm || 0), 'round'),
            address: {
                address: String(document.querySelector(`input[name="str_val"]`)?.value?.trim() || ''),
                address2: String(document.querySelector(`input[name="address2"]`)?.value?.trim() || ''),
                zipCode: String(document.querySelector(`input[name="zip_code"]`)?.value?.trim() || ''),
                cityName: String(document.querySelector(`input[name="city_name"]`)?.value?.trim() || ''),
                stateName: String(document.querySelector(`select[name="state_name"]`)?.value?.trim() || ''),
            },
            weightLossGoal: (() => {
                const rawValue = document.querySelector('weight-picker')?.value || '';
                const weight = parseInt(rawValue, 10);

                if (isNaN(weight) || weight <= 0) {
                    return '';
                } else if (weight >= 1 && weight <= 15) {
                    return '1-15lbs';
                } else if (weight >= 16 && weight <= 50) {
                    return '16-50lbs';
                } else {
                    return '51+lbs';
                }
            })(),
            ...(ef_transaction_id_get && { everflow_transaction_id: ef_transaction_id_get })
        };

        const payload = {
            programCode: 'glp1',
            offer: 2,
            patientStarter: updatedPatientData
        };

        try {
            const response = await fetch('https://api.humecare.com/v1/onboarding/patient-starter', {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorDetails = await response.json();
                console.error('Server Validation Errors:', errorDetails);
                return;
            }
            const result = await response.json();
            if (result.redirectUrl) {
                localStorage.setItem('quizRedirectPath', result.redirectUrl);
                window.location.href = result.redirectUrl;
            }
        } catch (err) {
            console.error('Submission failed:', err);
        }
    });

    document.querySelectorAll('input[name="important_is__protecting"]').forEach(radio => {
        radio.addEventListener('change', function() {
            const targetElementGood = document.querySelector('.this__will__apear__wouldbenice.would___be____good');
            const targetElementBad = document.querySelector('.this__will__apear__wouldbenice.would___be____bad');
            if (targetElementGood) {
                if (this.value === "It'd be nice" || this.value === "Very important") {
                    targetElementGood.classList.add('active');
                } else {
                    targetElementGood.classList.remove('active');
                }
            }
            if (targetElementBad) {
                if (this.value === "Not a priority, I just want to lose weight") {
                    targetElementBad.classList.add('active');
                } else {
                    targetElementBad.classList.remove('active');
                }
            }            
        });
    });    

})